// WOVN HOME PRODUCT BUILDER
// By BentoSMB - May 2019

// On mobile steps one thru four are combined

// Start the desktop display
$(document).ready(function () {
  
//   $('#share-button').click(function(){
//     var currentSessionStorage = Object.keys(sessionStorage).reduce(function(obj, key) {
//       if (!(key.includes('_product_builder_') || key.includes('_pb_'))) return obj
//       obj[key] = sessionStorage.getItem(key);
//       return obj
//     }, {});
    
//     console.log('currentSessionStorage', currentSessionStorage)
//     let sessionString = JSON.stringify(currentSessionStorage)
//     const urlParams = new URLSearchParams(window.location.search);
// 	const oldSessionString = urlParams.get('sessionString')
//     const oldSessionObject = JSON.parse(oldSessionString)
//     console.log('oldSessionString', oldSessionObject);
//     urlParams.append('sessionString', sessionString);
//     console.log('urlParams', urlParams.toString())
//     const currentURL = window.location.href
//     console.log("currentURL", currentURL + '?' + urlParams.toString());
//   })
  
//   const urlParams = new URLSearchParams(window.location.search);
//   const savedSessionString = urlParams.get('sessionString')
//   const savedSessionObject = JSON.parse(savedSessionString)
//   console.log('savedSessionObject', savedSessionObject);
  
//   Object.keys(savedSessionObject).map(savedItem => {
//     sessionStorage.setItem(savedItem, savedSessionObject[savedItem]);
//     console.log('savedItem', savedItem);
//     console.log('savedValue', savedSessionObject[savedItem]);
//   })
  
  
  var token;
  
  var drapesModify = false;
  var blindsModify = false;

  // DESKTOP

  //Drapes returning from FF
  var cameFromFitFinder = false;
  var cameFromFitFinderDrapes = false;
  var pb_gobackDrapes = false;

  var fitFinderComplete = sessionStorage.getItem('_fit_finder_complete');
  if (fitFinderComplete == 'complete') {
    cameFromFitFinder = true;
  } 


  var fitFinderStyle = sessionStorage.getItem('_fit_finder_style');
  if (fitFinderStyle == 'drapes') {
    cameFromFitFinderDrapes = true;
  } 
    
  var _pb_goback  = sessionStorage.getItem('_pb_goback');
  
  if (_pb_goback == 'desktop-step-5-drapes') {
    pb_gobackDrapes = true;
  } 

  
  if (cameFromFitFinder && cameFromFitFinderDrapes && pb_gobackDrapes) {
    goToSummaryDrapes();
  }
  
  
  //Blinds returning from FF
  var cameFromFitFinder = false;
  var cameFromFitFinderBlinds = false;
  var pb_gobackBlinds = false;

  var fitFinderComplete = sessionStorage.getItem('_fit_finder_complete');
  if (fitFinderComplete == 'complete') {
    cameFromFitFinder = true;
  }


  var fitFinderStyle = sessionStorage.getItem('_fit_finder_style');
  if (fitFinderStyle == 'shades') {
    cameFromFitFinderBlinds = true;
  } 
    
  var _pb_goback  = sessionStorage.getItem('_pb_goback');
  
  if (_pb_goback == 'desktop-step-5-blinds') {
    pb_gobackBlinds = true;
  } 
  
  if (cameFromFitFinder && cameFromFitFinderBlinds && pb_gobackBlinds) {    
    goToSummaryBlinds();
  }
  

  // Fade in the main display
  $('.desktop-select-product').fadeIn(800);
  
  
  var current_image = sessionStorage.getItem('_product_builder_final_image');
  var current_image_type = sessionStorage.getItem('_product_builder_final_image_type');
  if (current_image) {
    if (current_image_type === 'drapes') {
      $('.left').css("background-image", "url(" + current_image + ")");
    }
    else if (current_image_type === 'blinds') {
      $('.left-blinds').css("background-image", "url(" + current_image + ")");
    }
  }


  // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
  sessionStorage.setItem('_product_builder_stage', 'desktop-select-product');

  // SELECT A PRODUCT TYPE


  // DRAPES
  $('.custom-drapes').click(function () {

    // Store the product type
    sessionStorage.setItem('_product_builder_product', 'drapes');

    $('.desktop-select-product').fadeOut(400, function () {
      $('.drapes').fadeIn(400);
    });


    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'drapes');
  }); // END DRAPES


  // STEP ONE - Style: Euro, Triple Pinch, Flat Top
  $('.style-desktop').change(function () {
    console.log("QKJWEOQJWEIOWQJ");
    $('.builder-display-three-column').removeClass('selected-img');

    // Highlight the selected box
    var style = $('input[name=\'style-desktop\']:checked');
    var parent = style.closest('.builder-display-three-column');
    parent.addClass("selected-img");

    var styleThumb = style.attr("data-thumb");
    sessionStorage.setItem('_product_builder_style_thumb', styleThumb);

    // Change the image to reflect the correct style
    // .css({backgroundColor: "#ffe", borderLeft: "5px solid #ccc" })
    var styleType = style.val();

    // Get the data-bg value for the set item
    var bgData = style.attr('data-bg');

    $('.left').css("background-image", "url(" + bgData + ")");

    // Change only if the final image is not set
    var finalSet = sessionStorage.getItem('_product_builder_final_image');

    var pbProduct = sessionStorage.getItem('_pb_product');

    if (finalSet != null && pbProduct == 'drapes') {
      // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
      var getSwatch = sessionStorage.getItem('_product_builder_swatch');
      var lowercaseSwatch = getSwatch.toLowerCase();
      var splitSwatch = lowercaseSwatch.split(" ");
      var combineSwatch = splitSwatch.join("_");

      var removeNull = combineSwatch.replace('-desktop', '');

      var base = sessionStorage.getItem('_product_builder_base_image');
      if (styleType === "euro-desktop") {
        var base = "curtainrod2";
      }

      if (styleType === "triple-pinch-desktop") {
        var base = "curtainrod1";
      }

      if (styleType === "flat-top-desktop") {
        var base = "curtainrod3";
      }


      var imageWithoutExtension = `${removeNull}_${base}`;
      var removeNull2 = imageWithoutExtension.replace('_null', '');
      console.log(`liquidVariables`, liquidVariables)
      console.log(`removeNull2`, removeNull2);
      var finalImage = liquidVariables[removeNull2];
      var addBase = finalImage + "_" + base;

      $('.left').css("background-image", "url(" + finalImage + ")");
    }


    if (drapesModify) {
    }
    else {
      // Show the next button if a style is selected
      $('.next-step1').find('.call-to-action').prop('disabled', false);
    }

    var styleFinal = styleType.replace('-desktop', '');

    // Store the drape style
    sessionStorage.setItem('_product_builder_style', styleFinal);

    if (styleType === "euro-desktop") {
      var base = "curtainrod2";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "triple-pinch-desktop") {
      var base = "curtainrod1";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "flat-top-desktop") {
      var base = "curtainrod3";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

  }); // END STEP ONE

  // STEP TWO - Select the swatch
  $('.swatch-desktop').change(function () {

    //$('.swatch-slide').css("border-top","");
    $('.swatch-slide').removeClass("swatch-selected");

    // Highlight the selected box
    var selectedSwatch = $('input[name=\'swatch-desktop\']:checked');

    var parent = selectedSwatch.closest('.swatch-slide');
    //parent.css("border-top","10px solid #8b634b");
    parent.addClass("swatch-selected");

    var swatch = selectedSwatch.val();

    var swatchThumb = selectedSwatch.attr('data-thumb');

    sessionStorage.setItem('_product_builder_swatch_thumb', swatchThumb);

    var swatchFinal = swatch.replace('-desktop', '');

    // Store the fabric swatch
    sessionStorage.setItem('_product_builder_swatch', swatchFinal);

    
    if (drapesModify) {
    }
    else {
      // Show the next button if a fabric is selected
      $('.step2-drapes').prop("disabled", false);
    }
    

    // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
    var lowercaseSwatch = swatch.toLowerCase();
    var splitSwatch = lowercaseSwatch.split(" ");
    var combineSwatch = splitSwatch.join("_");

    var removeNull = combineSwatch.replace('-desktop', '');

    var base = sessionStorage.getItem('_product_builder_base_image');

    var imageWithoutExtension = `${removeNull}_${base}`;

    var removeNull2 = imageWithoutExtension.replace('_null', '');

    var finalImage = liquidVariables[removeNull2];
    console.log(`removeNull2`, removeNull2);
    console.log(`finalImage`, finalImage)
    var addBase = finalImage + "_" + base;

    $('.left').css("background-image", "url(" + finalImage + ")");

    sessionStorage.setItem('_product_builder_final_image', finalImage);
    sessionStorage.setItem('_product_builder_final_image_type', 'drapes');

  }); // END STEP TWO

  // STEP THREE - Select number of panels
  $('.panels-desktop').change(function () {

    $('.builder-display-two-column').removeClass('selected-img');

    // Highlight the selected box
    var panels = $('input[name=\'panels-desktop\']:checked');
    var parent = panels.closest('.builder-display-two-column');
    parent.addClass("selected-img");

    var numPanels = panels.val();

    var panelsThumb = panels.attr('data-thumb');

    if (drapesModify) {
    }
    else {
      // Show the next button if a fabric is selected
      $('.step3-drapes').prop("disabled", false);
    }

    var panelsTotal = numPanels.replace('-desktop', '');

    sessionStorage.setItem('_product_builder_panels_thumb', panelsThumb);

    // Store the number of panels
    sessionStorage.setItem('_product_builder_drapes_panels', panelsTotal);

  });
  // END STEP THREE

  // STEP FOUR - Select liner
  $('.liner-desktop').change(function () {

    $('.builder-display-three-column').removeClass('selected-img');

    // Highlight the selected box
    var liner = $('input[name=\'liner-desktop\']:checked');
    var parent = liner.closest('.builder-display-three-column');
    parent.addClass("selected-img");

    var typeLiner = liner.val();

    var linerThumb = liner.attr('data-thumb');

    if (drapesModify) {
    }
    else {
      // Show the next button if a fabric is selected
      $('.step4-drapes').prop("disabled", false);
    }

    var linerTotal = typeLiner.replace('-desktop', '');

    sessionStorage.setItem('_product_builder_liner_thumb', linerThumb);

    // Store the number of panels
    sessionStorage.setItem('_product_builder_drapes_liner', linerTotal);


  });

  // END STEP FOUR

  // SUBMIT DRAPES TO API
  // Send request to API to create the product; return value will be the variant ID; add this to the cart with AJAX; redirect to the cart
  $('.add-to-cart-drapes-desktop').click(function () {

    $('.add-to-cart-drapes-desktop').css("background-color","#cdb2a2")
    $('.add-to-cart-drapes-desktop').html("<img src='https://cdn.shopify.com/s/files/1/2435/4739/t/2/assets/ajax-loader.gif?27652' style='width: 16px !important;; height: 16px !important;'>");

    // Grab all the variables from local storage
    var width = parseFloat(sessionStorage.getItem('_product_builder_width'));
    var height = parseFloat(sessionStorage.getItem('_product_builder_height'));

    var heightFirst = firstNumber(height);
    var widthFirst = firstNumber(width);

    var heightFraction = convertDecimal(height);
    var widthFraction = convertDecimal(width);

    var totalHeight = heightFirst + ' ' + heightFraction + '" height';
    var totalWidth = widthFirst + ' ' + widthFraction + '" width';


    var style = sessionStorage.getItem('_product_builder_style');
    var styleNameSplit = style.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);
    var styleRemoveNull = styleName.replace(" undefined", "");

    var fabric = sessionStorage.getItem('_product_builder_swatch');
    var liner = sessionStorage.getItem('_product_builder_drapes_liner');

    var panel_count = 1;
    if (sessionStorage.getItem('_fit_finder_panel_type')) {
      panel_count = parseInt(sessionStorage.getItem('_fit_finder_panel_type'));
    }
    
    panel_count = parseInt($('.panel_count').html());


    var prodImage = sessionStorage.getItem('_product_builder_final_image');

    // Strip the version off the prodcut image
    // Append 'https' to the front of the file name

    var imageSplit = prodImage.split("?");

    var imageNoVersion = imageSplit[0];

    var imageLead = "https:";

    var finalImage = imageLead.concat(imageNoVersion);

    var finalPrice = sessionStorage.getItem('_product_builder_price');

    // Capitalize the first letter of all strings
    var capStyle = capitalize(styleRemoveNull);
    var capLiner = capitalize(liner);


    // Generate the auth token ||| storename|expiry|hash, where the hash is a SHA256 of the storename + expiry put together without the pipes,

    if (document.querySelector("meta[name='storeauthtoken']")) {
      token = document.querySelector("meta[name='storeauthtoken']").getAttribute("content");
    }

    // Call the API -- returned variable will be "variantID"
    $.ajax({
      url: 'https://app.wovnhome.com/v1/create-product',
      type: 'post',
      crossDomain: true,
      contentType: "application/json",
      dataType: 'json',
      headers: {
        'storeauthtoken': token,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        "width": totalWidth,
        "height": totalHeight,
        "type": "Drape",
        "style": capStyle,
        "fabric": fabric,
        "liner": capLiner,
        "prodImgURL": finalImage,
        "pricePerUnit": finalPrice
      }),
      success: function (variantID) {

        var a = variantID.variantID;

        var storedVariant = parseInt(a);

        // Now add to the cart. Liner and chain placement (for blinds) are line item properties.
        jQuery.post('/cart/add.js', {
          quantity: panel_count,
          id: storedVariant,
          properties: {
            'Liner': capLiner
          },

          success: function () {
            // Clear local storage
            sessionStorage.clear();

            // Redirect to the cart
            setTimeout(function() {
              $('.add-to-cart-drapes-desktop').hide();
              $('.go-to-cart-drapes').fadeIn(400);
              window.location.assign('/cart/');
            }, 1000);
          }
        });

        // Also add a spinner while things are loading, and hide the add to cart button
      },
      error: function () {
        console.log("The request failed");
      }
    });

  });



  // End submit drapes to API

  // NAVIGATION

  // Go back to product selector on Desktop
  $('.go-back-desktop-product').click(function () {
    $('.drapes').fadeOut(400, function () {
      $('.desktop-select-product').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-select-product');
  });

  // Step 1 to 2 on Desktop
  $('.step1-drapes').click(function () {
    $('.desktop-step-1-drapes').fadeOut(400, function () {

      // Determine if a swatch is already selected
      var selectCurrent = sessionStorage.getItem('_product_builder_swatch');


      if (selectCurrent) {

        // create the value name
        var desktop = "-desktop";
        var selected = selectCurrent.concat(desktop);
        var selectedSwatch = $('input[name=\''+selected+'\']:checked');

        var parent = selectedSwatch.closest('.swatch-slide');
        parent.css("border-top","10px solid #8b634b");
      }

      $('.desktop-step-2-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-2-drapes');
  });

  // Go back from Step 2 to Step 1 on Desktop
  $('.go-back-desktop-step-1').click(function () {
    $('.desktop-step-2-drapes').fadeOut(400, function () {
      $('.desktop-step-1-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-1-drapes');
  });

  // Step 2 to 3 on Desktop
  $('.step2-drapes').click(function () {
    $('.desktop-step-2-drapes').fadeOut(400, function () {
      $('.desktop-step-4-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-3-drapes');
  });

  // Go back from step 3 to 2 on Desktop
  $('.go-back-desktop-step-2').click(function () {
    $('.desktop-step-3-drapes').fadeOut(400, function () {
      $('.desktop-step-2-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-2-drapes');
  });

  // Step 3 to 4 on Desktop
  $('.step3-drapes').click(function () {
    $('.desktop-step-3-drapes').fadeOut(400, function () {
      $('.desktop-step-4-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-4-drapes');
  });

  // Go back from step 4 to 3 on Desktop
  $('.go-back-desktop-step-3').click(function () {
    $('.desktop-step-4-drapes').fadeOut(400, function () {
      $('.desktop-step-2-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-3-drapes');
  });

  // Step 4 to 5 on Desktop
  $('.step4-drapes').click(function () {
    $('.desktop-step-4-drapes').fadeOut(400, function () {
      $('.desktop-step-5-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-5-drapes');

    var pageURL = window.location.href;

    // Come back to here later
    sessionStorage.setItem('_pb_goback', 'desktop-step-5-drapes');
    sessionStorage.setItem('_pb_basepage', pageURL);
    sessionStorage.setItem('_pb_product', "drapes");


    //Check if the prev url was 
    var cameFromFitFinder = false;
    var cameFromFitFinderDrapes = false;

    var fitFinderComplete = sessionStorage.getItem('_fit_finder_complete');
    if (fitFinderComplete == 'complete') {
      cameFromFitFinder = true;
    } 


    var fitFinderStyle = sessionStorage.getItem('_fit_finder_style');
    if (fitFinderStyle == 'drapes') {
      cameFromFitFinderDrapes = true;
    } 

    if (cameFromFitFinder && cameFromFitFinderDrapes) {

      var fitFinderDrapeWidth = sessionStorage.getItem('_fit_finder_final_width');
      var fitFinderDrapeHeight = sessionStorage.getItem('_fit_finder_final_height');

      var heightConverted = splitDecimal(fitFinderDrapeHeight);
      var widthConverted = splitDecimal(fitFinderDrapeWidth);

      var heightFirst = firstNumber(fitFinderDrapeHeight);
      var widthFirst = firstNumber(fitFinderDrapeWidth);

      var heightFraction = convertDecimal(fitFinderDrapeHeight);
      var widthFraction = convertDecimal(fitFinderDrapeWidth);

      // Log the value of the width and height
      sessionStorage.setItem('_product_builder_width', fitFinderDrapeWidth);
      sessionStorage.setItem('_product_builder_height', fitFinderDrapeHeight);

      $('.drapes-height').val(heightFirst);
      $('.drapes-width').val(widthFirst);

      $('.drapes-height-eighths').val(heightConverted);
      $('.drapes-width-eighths').val(widthConverted);

      $('.drapes-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " +swatchName);
      $('.drapes-liner-final').html("<span class='summary-titles'>Liner</span><br><br><img src='" + linerImg + "'><br>" + linerName);

      if (widthFraction != "") {
        $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + widthFirst + "″ - " + widthFraction + "</div>");
      }

      else if (!widthFraction) {
        $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + widthFirst + "″</div>");
      }

      if (heightFraction != "") {
        $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + heightFirst + "″ - " + heightFraction + "</div>");
      }

      else {
        $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + heightFirst + "″</div>");
      }
    }
  });

  // Go back from step 5 to 4 on Desktop
  $('.go-back-desktop-step-4').click(function () {
    $('.desktop-step-5-drapes').fadeOut(400, function () {
      $('.desktop-step-4-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-4-drapes');
  });

  // Step 5 to Summary on Desktop
  $('.summary-drapes').click(function () {
    $('.desktop-step-5-drapes').fadeOut(400, function () {
      $('.drapes-start-over').show();
      $('.desktop-step-summary-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-summary-drapes');

    // If the measurements from the fit finder are set, pre-load the selection fields in the next step with the final width and height values. Make sure its for drapes.
    var fitFinderSet = sessionStorage.getItem('_fit_finder_complete');
    var fitFinderStyle = sessionStorage.getItem('_fit_finder_style');
    var productBuildStyle = sessionStorage.getItem('_product_builder_style');

    var styleNameSplit = productBuildStyle.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);

    var styleRemoveNull = styleName.replace(" undefined", "");

    var styleImg = sessionStorage.getItem('_product_builder_style_thumb');
    var swatchImg = sessionStorage.getItem('_product_builder_swatch_thumb');
    var panelsImg = sessionStorage.getItem('_product_builder_panels_thumb');
    var linerImg = sessionStorage.getItem('_product_builder_liner_thumb');

    var swatchName = sessionStorage.getItem('_product_builder_swatch');
    var panelsName = sessionStorage.getItem('_product_builder_drapes_panels');
    var linerName = sessionStorage.getItem('_product_builder_drapes_liner');
    var finalImage = sessionStorage.getItem('_product_builder_final_image');

    var panelWidthStorage = sessionStorage.getItem('')

    var fitFinderSet = null;

    if (fitFinderSet === "complete") {

      var fitFinderDrapeWidth = sessionStorage.getItem('_fit_finder_final_width');
      var fitFinderDrapeHeight = sessionStorage.getItem('_fit_finder_final_height');

      var heightConverted = splitDecimal(fitFinderDrapeHeight);
      var widthConverted = splitDecimal(fitFinderDrapeWidth);

      var heightFirst = firstNumber(fitFinderDrapeHeight);
      var widthFirst = firstNumber(fitFinderDrapeWidth);

      var heightFraction = convertDecimal(fitFinderDrapeHeight);
      var widthFraction = convertDecimal(fitFinderDrapeWidth);

      // Log the value of the width and height
      sessionStorage.setItem('_product_builder_width', fitFinderDrapeWidth);
      sessionStorage.setItem('_product_builder_height', fitFinderDrapeHeight);

      $('.drapes-height').val(heightFirst);
      $('.drapes-width').val(widthFirst);

      $('.drapes-height-eighths').val(heightConverted);
      $('.drapes-width-eighths').val(widthConverted);

      $('.drapes-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " +swatchName);
      $('.drapes-liner-final').html("<span class='summary-titles'>Lining</span><br><br><img src='" + linerImg + "'><br>" + linerName);

      if (widthFraction != "") {
        $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + widthFirst + "″ - " + widthFraction + "</div>");
      }

      else if (!widthFraction) {
        $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + widthFirst + "″</div>");
      }

      if (heightFraction != "") {
        $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + heightFirst + "″ - " + heightFraction + "</div>");
      }

      else {
        $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + heightFirst + "″</div>");
      }



    }

    else {

      var drapesWidth = parseFloat($('.drapes-width ').val()) || 0;
      var drapesWidthEighths = parseFloat($('.drapes-width-eighths').val()) || 0;

      var drapesHeight = parseFloat($('.drapes-height').val()) || 0;
      var drapesHeightEighths = parseFloat($('.drapes-height-eighths').val()) || 0;

      var drapesW = drapesWidth + drapesWidthEighths;
      var drapesH = drapesHeight + drapesHeightEighths;

      var heightFraction = convertDecimal(drapesHeightEighths);
      var widthFraction = convertDecimal(drapesWidthEighths);

      // Log the value of the width and height
      sessionStorage.setItem('_product_builder_width', drapesW);
      sessionStorage.setItem('_product_builder_height', drapesH);

      $('.drapes-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " +swatchName);
      $('.drapes-liner-final').html("<span class='summary-titles'>Lining</span><br><br><img src='" + linerImg + "'><br>" + linerName);

      if (widthFraction != "") {
        $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + drapesWidth + "″ - " + widthFraction + "</div>");
      }

      else if (!widthFraction) {
        $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + drapesWidth + "″</div>");
      }

      if (heightFraction != "") {
        $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + drapesHeight + "″ - " + heightFraction + "</div>");
      }

      else {
        $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + drapesHeight + "″</div>");
      }
    }

    // Grab all the variables from local storage
    var width = parseFloat(sessionStorage.getItem('_product_builder_width'));
    var height = parseFloat(sessionStorage.getItem('_product_builder_height'));

    var panelsString = sessionStorage.getItem('_product_builder_drapes_panels');
    let panels = 1;

    if (panelsString === "single") {
      panels = 1;
    } else if (panelsString === "double") {
      panels = 2;
    }

    var fabric = sessionStorage.getItem('_product_builder_swatch');
    var liner = sessionStorage.getItem('_product_builder_drapes_liner');
    var prodImage = sessionStorage.getItem('_product_builder_final_image');

    // Calculate the price.

    calcPriceDrapes();

  });
  

  // Go back to Style from Summary
  $('.go-back-drapes-style').click(function () {
    $('.desktop-step-summary-drapes').fadeOut(400, function () {
      $('.drapes-start-over').hide();
      drapesModify = true;
      $('.desktop-step-1-drapes').fadeIn(400);
    });

    // Show the hidden "return to Summary" button
    $('.summary-hidden-1').show();
    $('.next-step1').hide();
  });

  // Go back to Fabric Swatch from Summary
  $('.go-back-drapes-fabric').click(function () {
    $('.desktop-step-summary-drapes').fadeOut(400, function () {
      $('.go-back-desktop-step-1').hide();
      drapesModify = true;
      $('.drapes-start-over').hide();
      $('.desktop-step-2-drapes').fadeIn(400);
    });

    // Show the hidden "return to Summary" button
    $('.summary-hidden-2').show();
    $('.step2-drapes').hide();
  });

  // Go back to Panels from Summary
  $('.go-back-drapes-panels').click(function () {
    $('.desktop-step-summary-drapes').fadeOut(400, function () {
      drapesModify = true;
      $('.desktop-step-3-drapes').fadeIn(400);
    });

    // Show the hidden "return to Summary" button
    $('.summary-hidden-3').show();
    $('.step3-drapes').hide();
  });

  // Go back to Liner from Summary
  $('.go-back-drapes-liner').click(function () {
    $('.desktop-step-summary-drapes').fadeOut(400, function () {
      $('.go-back-desktop-step-3').hide();
      $('.drapes-start-over').hide();
      drapesModify = true;
      $('.desktop-step-4-drapes').fadeIn(400);
    });

    // Show the hidden "return to Summary" button
    $('.summary-hidden-4').show();
    $('.step4-drapes').hide();
  });

  // Go back to Measurements from Summary
  $('.go-back-drapes-measurements').click(function () {
    $('.desktop-step-summary-drapes').fadeOut(400, function () {
      $('.go-back-desktop-step-4').hide();
      $('.drapes-start-over').hide();
      drapesModify = true;
      $('.desktop-step-5-drapes').fadeIn(400);
    });

    // Show the hidden "return to Summary" button
    $('.summary-hidden-4').show();
    $('.next-step1').hide();
  });

  // Go back from Summary to step 5 on Desktop
  $('.go-back-desktop-step-5').click(function () {
    $('.desktop-step-summary-drapes').fadeOut(400, function () {
      $('.desktop-step-5-drapes').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-step-5-drapes');
  });

  $('.left').on('load', function () {
    $('.loader2').fadeOut(500);
  });



  // DRAPES GO BACK
  // Go back TO Summary from other steps
  $('.summary-hidden-1').click(function () {
    
    // Update values from this step
    var style = $('input[name=\'style-desktop\']:checked');

    var styleThumb = style.attr("data-thumb");

    sessionStorage.setItem('_product_builder_style_thumb', styleThumb);

    // Change the image to reflect the correct style
    // .css({backgroundColor: "#ffe", borderLeft: "5px solid #ccc" })
    var styleType = style.val();

    // Get the data-bg value for the set item
    var bgData = style.attr('data-bg');

    var styleFinal = styleType.replace('-desktop', '');

    // Store the drape style
    sessionStorage.setItem('_product_builder_style', styleFinal);

    var base = "";

    // Store the drape style
    sessionStorage.setItem('_product_builder_style', styleFinal);

    if (styleType === "euro-desktop") {
      var base = "curtainrod2";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "triple-pinch-desktop") {
      var base = "curtainrod1";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "flat-top-desktop") {
      var base = "curtainrod3";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    // Grab the changed variables, including the changed final image

    var prodBuild = sessionStorage.getItem('_product_builder_style');

    var styleNameSplit = prodBuild.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);

    var styleRemoveNull = styleName.replace(" undefined", "");

    var styleImg = sessionStorage.getItem('_product_builder_style_thumb');


    // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
    var getSwatch = sessionStorage.getItem('_product_builder_swatch');
    var lowercaseSwatch = getSwatch.toLowerCase();
    var splitSwatch = lowercaseSwatch.split(" ");
    var combineSwatch = splitSwatch.join("_");

    var removeNull = combineSwatch.replace('-desktop', '');

    var base = sessionStorage.getItem('_product_builder_base_image');

    var imageWithoutExtension = `${removeNull}_${base}`;

    var removeNull2 = imageWithoutExtension.replace('_null', '');

    var finalImage = liquidVariables[removeNull2];

    var addBase = finalImage + "_" + base;

    $('.left').css("background-image", "url(" + finalImage + ")");

    $('.drapes-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " + getSwatch);



    $('.desktop-step-1-drapes').fadeOut(400, function () {
	  drapesModify = false;
      $('.drapes-start-over').show();
      calcPriceDrapes();

      $('.desktop-step-summary-drapes').fadeIn(400);
    });


  });

  $('.summary-hidden-2').click(function () {

    // Re-declare the Style variable, if its changed
    var newFabric = $('input[name=\'swatch-desktop\']:checked').val();
    var newFabricImg = $('input[name=\'swatch-desktop\']:checked').attr('data-thumb');

    var swatchFinal = newFabric.replace('-desktop', '');

    sessionStorage.setItem('_product_builder_swatch', swatchFinal);

    var prodBuild = sessionStorage.getItem('_product_builder_style');

    var styleNameSplit = prodBuild.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);

    var styleRemoveNull = styleName.replace(" undefined", "");

    $('.desktop-step-2-drapes').fadeOut(400, function () {
      $('.drapes-start-over').show();
	  drapesModify = false;
      calcPriceDrapes();

      $('.desktop-step-summary-drapes').fadeIn(400);
    });


    $('.drapes-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + newFabricImg + "'><br>" + styleRemoveNull + " - " + swatchFinal);

  });

  $('.summary-hidden-3').click(function () {
    
    var newPanels = $('input[name=\'panels-desktop\']:checked');

    var newNumPanels = newPanels.val();

    var newPanelsThumb = newPanels.attr('data-thumb');

    sessionStorage.setItem('_product_builder_panels_thumb', newPanelsThumb);

    var panelsFinal = newNumPanels.replace('-desktop', '');

    // Store the number of panels
    sessionStorage.setItem('_product_builder_drapes_panels', panelsFinal);

    $('.desktop-step-3-drapes').fadeOut(400, function () {
      $('.drapes-start-over').show();
      drapesModify = false;
      calcPriceDrapes();
      $('.desktop-step-summary-drapes').fadeIn(400);
    });

  });

  $('.summary-hidden-4').click(function () {
    $('.desktop-step4-blinds').fadeOut(400, function () {
      $('.drapes-start-over').show();
      drapesModify = false;
      $('.desktop-summary-blinds').fadeIn(400);
    });

    var newLiner = $('input[name=\'liner-desktop\']:checked');

    var newTypeLiner = newLiner.val();

    var newLinerThumb = newLiner.attr('data-thumb');

    var linerFinal = newTypeLiner.replace('-desktop', '');

    sessionStorage.setItem('_product_builder_liner_thumb', newLinerThumb);

    $('.desktop-step-4-drapes').fadeOut(400, function () {
      calcPriceDrapes();
      $('.desktop-step-summary-drapes').fadeIn(400);
    });

    // Store the number of panels
    sessionStorage.setItem('_product_builder_drapes_liner', linerFinal);

    $('.drapes-liner-final').html("Liner<br><br><img src='" + newLinerThumb + "'><br>" + linerFinal);

  });




  // START BLINDS
  $('.custom-shades').click(function () {

    $('.desktop-select-product').fadeOut(400, function () {
      $('.blinds').fadeIn(400);
      $('.desktop-step1-blinds').fadeIn(400);
    });

  });

  $('.style-blinds-desktop').change(function () {

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-product');

    // Store the product type
    sessionStorage.setItem('_product_builder_product', 'blinds');

    $('.builder-display-three-column').removeClass('selected-img');

    // Highlight the selected box
    var style = $('input[name=\'style-blinds-desktop\']:checked');
    var parent = style.closest('.builder-display-three-column');
    parent.addClass("selected-img");

    var styleThumb = style.attr("data-thumb");

    sessionStorage.setItem('_product_builder_style_thumb', styleThumb);

    // Change the image to reflect the correct style
    // .css({backgroundColor: "#ffe", borderLeft: "5px solid #ccc" })
    var styleType = style.val();

    // Get the data-bg value for the set item
    var bgData = style.attr('data-bg');

    $('.left-blinds').css("background-image", "url(" + bgData + ")");

    if (blindsModify) {
      
    }
    else {
      // Show the next button if a style is selected
      $('.next-step1').find('.call-to-action').prop('disabled', false);
    }

    var styleFinal = styleType.replace('-desktop', '');

    // Store the drape style
    sessionStorage.setItem('_product_builder_style', styleFinal);

    var base = "";

    if (styleType === "ribbed-desktop") {
      base = "ribbed";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "flat-desktop") {
      base = "flat";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "soft-desktop") {
      base = "soft";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    // Change only if the final image is not set
    var finalSet = sessionStorage.getItem('_product_builder_final_image');

    var pbProduct = sessionStorage.getItem('_pb_product');

    if (finalSet != null && pbProduct == 'shades') {
      // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
      var getSwatch = sessionStorage.getItem('_product_builder_swatch');
      var lowercaseSwatch = getSwatch.toLowerCase();
      var splitSwatch = lowercaseSwatch.split(" ");
      var combineSwatch = splitSwatch.join("_");

      var removeNull = combineSwatch.replace('-desktop', '');
      var base = sessionStorage.getItem('_product_builder_base_image');
      var imageWithoutExtension = `${removeNull}_${base}`;
      var removeNull2 = imageWithoutExtension.replace('_null', '');
      var finalImage = blindsLiquidVariable[removeNull2];
      var addBase = finalImage + "_" + base;
      $('.left-blinds').css("background-image", "url(" + finalImage + ")");
    }

  }); // End step 1

  // Move on to Step 2
  $('.step1-blinds').click(function () {

    $('.desktop-step1-blinds').fadeOut(400, function () {
      $('.desktop-step2-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-fabric');
  }); // End step 2

  // Select a swatch
  $('.swatch-blinds-desktop').change(function () {

    // Highlight the selected box
    //$('.swatch-slide').css("border-top","");
    $('.swatch-slide').removeClass("swatch-selected");

    // Highlight the selected box
    var selectedSwatch = $('input[name=\'swatch-blinds-desktop\']:checked');

    var parent = selectedSwatch.closest('.swatch-slide');
    //parent.css("border-top","10px solid #8b634b");
    parent.addClass("swatch-selected");

    var swatch = selectedSwatch.val();

    var swatchThumb = selectedSwatch.attr('data-thumb');

    sessionStorage.setItem('_product_builder_swatch_thumb', swatchThumb);

    var swatchFinal = swatch.replace('-blinds-desktop', '');

    // Store the fabric swatch
    sessionStorage.setItem('_product_builder_swatch', swatchFinal);

    if (blindsModify) {
      
    }
    else {
      // Show the next button if a fabric is selected
      $('.step2-blinds').prop("disabled", false);
    }

    // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
    var lowercaseSwatch = swatch.toLowerCase();
    var splitSwatch = lowercaseSwatch.split(" ");
    var combineSwatch = splitSwatch.join("_");

    var removeNull = combineSwatch.replace('-blinds-desktop', '');

    var base = sessionStorage.getItem('_product_builder_base_image');

    var imageWithoutExtension = `${removeNull}_${base}`;

    var removeNull2 = imageWithoutExtension.replace('_null', '');

    var finalImage = blindsLiquidVariable[removeNull2];

    var addBase = finalImage + "_" + base;

    $('.left-blinds').css("background-image", "url(" + finalImage + ")");

    sessionStorage.setItem('_product_builder_final_image', finalImage);
    sessionStorage.setItem('_product_builder_final_image_type', 'blinds');

  });

  // Move on to Step 3
  $('.step2-blinds').click(function () {

    $('.desktop-step2-blinds').fadeOut(400, function () {
      $('.desktop-step3-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-cord');

  }); // End step 3

  var cordColour, cordSel
  // Change a cord option
  $('.cord-desktop').change(function () {
    $('.builder-display-two-column.cord-position').removeClass('selected-img');

    // Highlight the selected box
    var cord = $('input[name=\'cord-desktop\']:checked');
    console.log(`cord`, cord)
    var parent = cord.closest('.builder-display-two-column');
    parent.addClass("selected-img");

    cordSel = cord.val();

    var cordThumb = cord.attr('data-thumb');

    if (!cordColour) {
      
    }
    else {
      // Show the next button if a fabric is selected
      $('.step3-blinds').prop("disabled", false);
    }

    var cordFinal = cordSel.replace('-desktop', '');

    sessionStorage.setItem('_product_builder_cord_thumb', cordThumb);

    // Store the number of panels
    sessionStorage.setItem('_product_builder_cord_placement', cordFinal);

  });

  $('.cord-colour-desktop').change(function(e){
    console.log(`e.target.dataset.thumb`, e.target.dataset.thumb)
    $('.builder-display-two-column.cord-color').removeClass('selected-img');

    var parent = $(e.target).closest('.builder-display-two-column');
    parent.addClass("selected-img");
    cordColour = e.target.value;
    var cordColourThumb = e.target.dataset.thumb;
    sessionStorage.setItem('_product_builder_cord_color_thumb', cordColourThumb);
    sessionStorage.setItem('_product_builder_cord_color', cordColour);
    if (!cordSel) {
      
    }
    else {
      // Show the next button if a fabric is selected
      $('.step3-blinds').prop("disabled", false);
    }
  })


  // Move on to Step 4
  $('.step3-blinds').click(function () {

    $('.desktop-step3-blinds').fadeOut(400, function () {

      var blindStyle = sessionStorage.getItem('_product_builder_style');

      // Hide the three options if the ribbed option is selected
      if (blindStyle === "ribbed") {
        $('.lining-choice-three').hide();
        $('.lining-choice-two').show();
      }

      else {
        $('.lining-choice-three').show();
        $('.lining-choice-two').hide();
      }

      $('.desktop-step4-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-liner');

  });


  // Select a liner
  $('.liner-blinds-desktop').change(function () {

    var blindStyle = sessionStorage.getItem('_product_builder_style');

    // Hide the three options if the ribbed option is selected
    if (blindStyle === "ribbed") {
      $('.builder-display-two-column').removeClass('selected-img');
      // Highlight the selected box
      var liner = $('input[name=\'liner-blinds-desktop\']:checked');
      var parent = liner.closest('.builder-display-two-column');
      parent.addClass("selected-img");
    }

    else {
      $('.builder-display-three-column').removeClass('selected-img');
      // Highlight the selected box
      var liner = $('input[name=\'liner-blinds-desktop\']:checked');
      var liner = $(this);
      var parent = liner.closest('.common-parent');
      parent.addClass("selected-img");
    }

    var linerType = $(this).val();

    $('input[value='+linerType+']').closest('.common-parent').addClass("selected-img");

    var typeLiner = liner.val();

    var linerThumb = liner.attr('data-thumb');

    
    if (blindsModify) {
      
    }
    else {
      // Show the next button if a fabric is selected
      $('.step4-blinds').prop("disabled", false);
    }

    var linerTotal = typeLiner.replace('-blinds-desktop', '');

    sessionStorage.setItem('_product_builder_liner_thumb', linerThumb);

    // Store the number of panels
    sessionStorage.setItem('_product_builder_blinds_liner', linerTotal);
  });


  // Move on to Step 5
  $('.step4-blinds').click(function () {

    $('.desktop-step4-blinds').fadeOut(400, function () {
      $('.desktop-step5-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-measurements');

    var pageURL = window.location.href;

    // Come back to here later
    sessionStorage.setItem('_pb_goback', 'desktop-step-5-blinds');
    sessionStorage.setItem('_pb_basepage', pageURL);
    sessionStorage.setItem('_pb_product', "shades");


    // If the measurements from the fit finder are set, pre-load the selection fields in the next step with the final width and height values. Make sure its for drapes.
    var fitFinderSet = sessionStorage.getItem('_fit_finder_complete');
    var fitFinderStyle = sessionStorage.getItem('_fit_finder_style');
    var productBuildStyle = sessionStorage.getItem('_product_builder_style');


    if (fitFinderSet === "complete") {

      if (fitFinderStyle === "shades") {

        var fitFinderDrapeWidth = sessionStorage.getItem('_fit_finder_final_width');
        var fitFinderDrapeHeight = sessionStorage.getItem('_fit_finder_final_height');

        var heightConverted = splitDecimal(fitFinderDrapeHeight);
        var widthConverted = splitDecimal(fitFinderDrapeWidth);

        var heightFirst = firstNumber(fitFinderDrapeHeight);
        var widthFirst = firstNumber(fitFinderDrapeWidth);

        var heightFraction = convertDecimal(fitFinderDrapeHeight);
        var widthFraction = convertDecimal(fitFinderDrapeWidth);

        // Log the value of the width and height
        sessionStorage.setItem('_product_builder_width', fitFinderDrapeWidth);
        sessionStorage.setItem('_product_builder_height', fitFinderDrapeHeight);

        $('.blinds-height').val(heightFirst);
        $('.blinds-width').val(widthFirst);

        $('.blinds-height-eighths').val(heightConverted);
        $('.blinds-width-eighths').val(widthConverted);

      }
    }
  });


  // Move on to Summary
  $('.step5-blinds').click(function () {

    $('.desktop-step5-blinds').fadeOut(400, function () {
      $('.blinds-start-over').show();
      $('.desktop-summary-blinds').fadeIn(400);
    });

    // Set the measurements
    var blindsWidth = parseFloat($('.blinds-width ').val()) || 0;
    var blindsWidthEighths = parseFloat($('.blinds-width-eighths').val()) || 0;

    var blindsHeight = parseFloat($('.blinds-height').val()) || 0;
    var blindsHeightEighths = parseFloat($('.blinds-height-eighths').val()) || 0;

    var blindsW = blindsWidth + blindsWidthEighths;
    var blindsH = blindsHeight + blindsHeightEighths;

    var heightFraction = convertDecimal(blindsHeightEighths);
    var widthFraction = convertDecimal(blindsWidthEighths);

    // Log the value of the width and height
    sessionStorage.setItem('_product_builder_width', blindsW);
    sessionStorage.setItem('_product_builder_height', blindsH);
    
    // Set the measurements
    var mountLocation = $('#mount-location-desktop').val();

    sessionStorage.setItem('_fit_finder_mountType', mountLocation);

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-summary');

    var prodBuild = sessionStorage.getItem('_product_builder_style');

    var styleNameSplit = prodBuild.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);

    var styleRemoveNull = styleName.replace(" undefined", "");

    var styleImg = sessionStorage.getItem('_product_builder_style_thumb');
    var swatchImg = sessionStorage.getItem('_product_builder_swatch_thumb');
    var cordImg = sessionStorage.getItem('_product_builder_cord_thumb');
    var cordColourImg = sessionStorage.getItem('_product_builder_cord_color_thumb');
    var linerImg = sessionStorage.getItem('_product_builder_liner_thumb');

    var swatchName = sessionStorage.getItem('_product_builder_swatch');
    var linerName = sessionStorage.getItem('_product_builder_blinds_liner');
    var prodStyle = sessionStorage.getItem('_product_builder_style');
    
    var cordName = sessionStorage.getItem('_product_builder_cord_placement');
    var cordColourName = sessionStorage.getItem('_product_builder_cord_color')

    var blindW = parseFloat(sessionStorage.getItem('_product_builder_width'));
    var blindH = parseFloat(sessionStorage.getItem('_product_builder_height'));

    var heightFirst = firstNumber(blindH);
    var widthFirst = firstNumber(blindW);

    var heightFraction = convertDecimal(blindH);
    var widthFraction = convertDecimal(blindW);

    var finalImage = sessionStorage.getItem('_product_builder_final_image');

    $('.blinds-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " + swatchName);
    $('.blinds-cord-final').html("<span class='summary-titles'>Cord Position</span><br><br><img src='" + cordImg + "'><br>" + cordName + "<br><br><span style='display: block; margin-bottom: 8px; font-size: 18px' class='summary-titles'>Cord Color: <b>" + cordColourName + "</b></span>");
    $('.blinds-liner-final').html("<span class='summary-titles'>Lining</span><br><br><img src='" + linerImg + "'><br>" + linerName);

    if (widthFraction != "") {
      $('.panel-width').html("<span class='summary-titles'>Shade Width:</span><br><div class='display-box'>" + widthFirst + "″ - " + widthFraction + "</div>");
    }

    else if (!widthFraction) {
      $('.panel-width').html("<span class='summary-titles'>Shade Width:</span><br><div class='display-box'>" + widthFirst + "″</div>");
    }

    if (heightFraction != "") {
      $('.panel-height').html("<span class='summary-titles'>Shade Height:</span><br><div class='display-box'>" + heightFirst + "″ - " + heightFraction + "</div>");
    }

    else {
      $('.panel-height').html("<span class='summary-titles'>Shade Height:</span><br><div class='display-box'>" + heightFirst + "″</div>");
    }

    // Calculate the price.
    calcPriceBlinds();
  });



  // ADD TO CART FOR BLINDS
  $('.add-to-cart-blinds-desktop').click(function () {

    $('.add-to-cart-blinds-desktop').css("background-color","#cdb2a2")
    $('.add-to-cart-blinds-desktop').html("<img src='https://cdn.shopify.com/s/files/1/2435/4739/t/2/assets/ajax-loader.gif?27652' style='width: 16px !important;; height: 16px !important;'>");

    // Variables
    var prodBuild = capitalize(sessionStorage.getItem('_product_builder_style'));

    var styleNameSplit = prodBuild.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);

    var styleRemoveNull = capitalize(styleName.replace(" undefined", ""));

    var swatchName = sessionStorage.getItem('_product_builder_swatch');

    var linerName = capitalize(sessionStorage.getItem('_product_builder_blinds_liner'));

    var cordName = capitalize(sessionStorage.getItem('_product_builder_cord_placement'));
    var cordColourName = sessionStorage.getItem('_product_builder_cord_color')

    var blindW = parseFloat(sessionStorage.getItem('_product_builder_width'));
    var blindH = parseFloat(sessionStorage.getItem('_product_builder_height'));


    var heightFirst = firstNumber(blindH);
    var widthFirst = firstNumber(blindW);

    var heightFraction = convertDecimal(blindH);
    var widthFraction = convertDecimal(blindW);

    var totalHeight = heightFirst + ' ' + heightFraction + '" height';
    var totalWidth = widthFirst + ' ' + widthFraction + '" width';

    var finalPrice = sessionStorage.getItem('_product_builder_price');

    var prodImage = sessionStorage.getItem('_product_builder_final_image');
    
    var mountType = sessionStorage.getItem('_fit_finder_mountType');
    
    var mountTypeText;
    if (mountType) {
       var temp = mountType.split('-');
      for (var i = 0; i < temp.length; i++) {
        temp[i] = capitalize(temp[i]);
      }
      temp = temp.join(' ');
      mountTypeText = temp;
    }
    else {
      mountTypeText = "Not Specified" 
    }

    // Strip the version off the prodcut image
    // Append 'https' to the front of the file name

    var imageSplit = prodImage.split("?");
    var imageNoVersion = imageSplit[0];
    var imageLead = "https:";
    var finalImage = imageLead.concat(imageNoVersion);

    if (document.querySelector("meta[name='storeauthtoken']")) {
      token = document.querySelector("meta[name='storeauthtoken']").getAttribute("content");
    }

    // Call the API -- returned variable will be "variantID"
    $.ajax({
      url: 'https://app.wovnhome.com/v1/create-product',
      type: 'post',
      crossDomain: true,
      contentType: "application/json",
      dataType: 'json',
      headers: {
        'storeauthtoken': token,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        "width": totalWidth,
        "height": totalHeight,
        "type": "Shade",
        "style": styleRemoveNull,
        "fabric": swatchName,
        "liner": linerName,
        "prodImgURL": finalImage,
        "pricePerUnit": finalPrice
      }),
      success: function (variantID) {
        var a = variantID.variantID;
        var storedVariant = parseInt(a);

        // Now add to the cart. Liner and chain placement (for blinds) are line item properties.
        jQuery.post('/cart/add.js', {
          quantity: 1,
          id: storedVariant,
          properties: {
            'Lining': linerName,
            'Cord Position': cordName,
            'Cord Color': cordColourName,
            'Mount Location': mountTypeText
          },

          success: function () {
            // Clear local storage
            sessionStorage.clear();

            // Redirect to the cart
            setTimeout(function() {
              $('.add-to-cart-blinds-desktop').hide();
              $('.go-to-cart-blinds').fadeIn(400);
              window.location.assign('/cart/');
            }, 1000);

          }
        });

        // Also add a spinner while things are loading, and hide the add to cart button
      },
      error: function () {
        console.log("The request failed");
      }
    });
  });


  // Navigate back + forth

  // From Step 1 to Choose Product
  $('.go-back-desktop-product').click(function () {
    $('.blinds').fadeOut(400, function () {
      $('.desktop-select-product').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-product');
  });

  // From Step 2 to Step 1
  $('.go-back-desktop-style').click(function () {
    $('.desktop-step2-blinds').fadeOut(400, function () {
      $('.desktop-step1-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-fabric');
  });

  // From Step 3 to Step 2
  $('.go-back-desktop-swatch').click(function () {
    $('.desktop-step3-blinds').fadeOut(400, function () {
      $('.desktop-step2-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-cord');
  });

  // From Step 4 to Step 3
  $('.go-back-desktop-cord').click(function () {
    $('.desktop-step4-blinds').fadeOut(400, function () {
      $('.desktop-step3-blinds').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-liner');
  });

  // From Step 5 to Step 4
  $('.go-back-desktop-measurements').click(function () {
    $('.desktop-step5-blinds').fadeOut(400, function () {
      $('.desktop-step4-blinds').fadeIn(400);
    });
    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-measurements');
  });

  // From Step Summary to Step 5
  $('.go-back-desktop-summary').click(function () {
    $('.desktop-summary-blinds').fadeOut(400, function () {
      $('.desktop-step5-blinds').fadeIn(400);
    });
    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-summary');
  });


  // Return from Summary to each stage
  $('.go-back-blinds-style').click(function () {
    $('.desktop-summary-blinds').fadeOut(400, function () {
      blindsModify = true;
      $('.step1-blinds').hide();
      $('.blinds-start-over').hide();
      $('.desktop-step1-blinds').fadeIn(400);
    });
    $('.summary-hidden-1-blinds').show();
  });

  $('.go-back-blinds-fabric').click(function () {
    $('.desktop-summary-blinds').fadeOut(400, function () {
      blindsModify = true;
      $('.go-back-desktop-style').hide();
      $('.blinds-start-over').hide();
      $('.desktop-step2-blinds').fadeIn(400);
    });
    // Show the selected value
    $('.summary-hidden-2-blinds').show();
  });

  $('.go-back-blinds-panels').click(function () {
    $('.desktop-summary-blinds').fadeOut(400, function () {
      blindsModify = true;
      $('.blinds-start-over').hide();
      $('.go-back-desktop-swatch').hide();
      $('.desktop-step3-blinds').fadeIn(400);
    });
    $('.summary-hidden-3-blinds').show();
  });

  $('.go-back-blinds-liner').click(function () {
    $('.desktop-summary-blinds').fadeOut(400, function () {
      blindsModify = true;
      $('.blinds-start-over').hide();
      $('.go-back-desktop-cord').hide();
      $('.summary-4-blinds').show();
      var blindStyle = sessionStorage.getItem('_product_builder_style');
      // Hide the three options if the ribbed option is selected
      if (blindStyle === "ribbed") {
        $('.builder-display-two-column').removeClass('selected-img');
        // Highlight the selected box
        var liner = $('input[name=\'liner-blinds-desktop\']:checked');
        var parent = liner.closest('.builder-display-two-column');
        parent.addClass("selected-img");
        $('.lining-choice-two').fadeIn(400);
      }
      else {
        $('.builder-display-three-column').removeClass('selected-img');
        // Highlight the selected box
        var liner = $('input[name=\'liner-blinds-desktop\']:checked');
        var parent = liner.closest('.builder-display-three-column');
        parent.addClass("selected-img");
        $('.lining-choice-three').fadeIn(400);
      }
      $('.desktop-step4-blinds').fadeIn(400);
    });
  });
  
  $('.go-back-blinds-measurements').click(function () {
    $('.desktop-summary-blinds').fadeOut(400, function () {
      $('.blinds-start-over').hide();
      $('.go-back-desktop-measurements').hide();
      blindsModify = true;
      $('.desktop-step5-blinds').fadeIn(400);
    });
    $('.summary-hidden-5').show();
  });


  // Go back TO Summary from other steps
  $('.summary-hidden-1-blinds').click(function () {
    // Update values from this step
    var style = $('input[name=\'style-blinds-desktop\']:checked');

    var styleThumb = style.attr("data-thumb");


    // Change the image to reflect the correct style
    // .css({backgroundColor: "#ffe", borderLeft: "5px solid #ccc" })
    var styleType = style.val();

    // Get the data-bg value for the set item
    var bgData = style.attr('data-bg');

    var styleFinal = styleType.replace('-desktop', '');

    // Store the drape style
    sessionStorage.setItem('_product_builder_style', styleFinal);

    var base = "";

    // Store the drape style
    sessionStorage.setItem('_product_builder_style', styleFinal);

    if (styleType === "ribbed-desktop") {
      base = "ribbed";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "flat-desktop") {
      base = "flat";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (styleType === "soft-desktop") {
      base = "soft";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    // Grab the changed variables, including the changed final image

    var prodBuild = sessionStorage.getItem('_product_builder_style');

    var styleNameSplit = prodBuild.split("-");

    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);

    var styleRemoveNull = styleName.replace(" undefined", "");

    var styleImg = sessionStorage.getItem('_product_builder_style_thumb');


    // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
    var getSwatch = sessionStorage.getItem('_product_builder_swatch');
    var lowercaseSwatch = getSwatch.toLowerCase();
    var splitSwatch = lowercaseSwatch.split(" ");
    var combineSwatch = splitSwatch.join("_");

    var removeNull = combineSwatch.replace('-desktop', '');

    var base = sessionStorage.getItem('_product_builder_base_image');

    var imageWithoutExtension = `${removeNull}_${base}`;
    var removeNull2 = imageWithoutExtension.replace('_null', '');
    var finalImage = blindsLiquidVariable[removeNull2];
    var addBase = finalImage + "_" + base;
    var blindStyle = sessionStorage.getItem('_product_builder_style');

    // Hide the three options if the ribbed option is selected
    if (blindStyle === "ribbed") {
      $('.lining-choice-three').hide();
      $('.lining-choice-two').show();
    }

    else {
      $('.lining-choice-three').show();
      $('.lining-choice-two').hide();
    }

    $('.left-blinds').css("background-image", "url(" + finalImage + ")");

    $('.blinds-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " + getSwatch);

    calcPriceBlinds();

    $('.desktop-step1-blinds').fadeOut(400, function () {
      $('.blinds-start-over').show();
      blindsModify = false;
      $('.desktop-summary-blinds').fadeIn(400);
    });


  });

  $('.summary-hidden-2-blinds').click(function () {

    // Re-declare the Swatch variable, if its changed
    var newFabric = $('input[name=\'swatch-blinds-desktop\']:checked').val();
    var newFabricImg = $('input[name=\'swatch-blinds-desktop\']:checked').attr('data-thumb');

    var swatchFinal = newFabric.replace('-blinds-desktop', '');

    var baseProduct = sessionStorage.getItem('_product_builder_style');

    var finalImage = sessionStorage.getItem('_product_builder_final_image');

    sessionStorage.setItem('_product_builder_swatch', swatchFinal);

    calcPriceBlinds();

    $('.blinds-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + baseProduct + " - " + swatchFinal);

    $('.desktop-step2-blinds').fadeOut(400, function () {
      $('.blinds-start-over').show();
      blindsModify = false;
      $('.desktop-summary-blinds').fadeIn(400);
    });

  });

  $('.summary-hidden-3-blinds').click(function () {

    // Update values from this step
    var cord = $('input[name=\'cord-desktop\']:checked');

    var cordSel = cord.val();
    var cordThumb = cord.attr('data-thumb');
    var cordFinal = cordSel.replace('-desktop', '');
    sessionStorage.setItem('_product_builder_cord_thumb', cordThumb);

    // Store the number of panels
    sessionStorage.setItem('_product_builder_cord_placement', cordFinal);

    // Grab the changed variables
    var cordName = sessionStorage.getItem('_product_builder_cord_placement');
    var cordColourName = sessionStorage.getItem('_product_builder_cord_color')

    var cordImg = sessionStorage.getItem('_product_builder_cord_thumb');

    calcPriceBlinds();

    $('.blinds-cord-final').html("<span class='summary-titles'>Cord Position</span><br><br><img src='" + cordImg + "'><br>" + cordName + "<br><br><span style='display: block; margin-bottom: 8px; font-size: 18px' class='summary-titles'>Cord Color: <b>" + cordColourName + "</b></span>");

    $('.desktop-step3-blinds').fadeOut(400, function () {
      $('.blinds-start-over').show();
      blindsModify = false;
      $('.desktop-summary-blinds').fadeIn(400);
    });

  });

  $('.summary-hidden-4-blinds').click(function () {
    $('.desktop-step4-blinds').fadeOut(400, function () {

      $('.blinds-start-over').show();
      blindsModify = false;
      
      // Update values from this step
      var liner = $('input[name=\'liner-blinds-desktop\']:checked');
      var typeLiner = liner.val();
      var linerThumb = liner.attr('data-thumb');
      var linerTotal = typeLiner.replace('-blinds-desktop', '');
      sessionStorage.setItem('_product_builder_liner_thumb', linerThumb);

      // Store the number of panels
      sessionStorage.setItem('_product_builder_blinds_liner', linerTotal);

      // Grab the changed variables
      var linerName = sessionStorage.getItem('_product_builder_blinds_liner');
      var linerImg = sessionStorage.getItem('_product_builder_liner_thumb');

      $('.blinds-liner-final').html("<span class='summary-titles'>Lining</span><br><br><img src='" + linerImg + "'><br>" + linerName);

      calcPriceBlinds();

      $('.desktop-summary-blinds').fadeIn(400);
    });



  });


  // END BLINDS



  // START LUMBAR PILLOWS
  $('.custom-lumbar-pillows').click(function(){

    // Store the product type
    sessionStorage.setItem('_product_builder_product', 'lumbar-pillow');

    $('.desktop-select-product').fadeOut(400, function () {
      $('.pillows-lumbar').fadeIn(400);
      $('.desktop-step1-lumbar-pillows').fadeIn(400);
    });

    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'pillows-lumbar');

  });

  // Step One - Select Size
  $('.size-lumbar-desktop').change(function(){

    // Store the product type
    sessionStorage.setItem('_product_builder_product', 'lumbar-pillow');

    $('.builder-display-three-column-wide').removeClass('selected-img');

    // Highlight the selected box
    var size = $('input[name=\'size-lumbar-desktop\']:checked');
    var parent = size.closest('.builder-display-three-column-wide');
    parent.addClass("selected-img");

    var sizeThumb = size.attr("data-thumb");

    sessionStorage.setItem('_product_builder_pillow_size_thumb', sizeThumb);

    // Change the image to reflect the correct style
    // .css({backgroundColor: "#ffe", borderLeft: "5px solid #ccc" })
    var pillowSize = size.val();

    // Get the data-bg value for the set item
    var bgData = size.attr('data-bg');

    $('.left-pillows').css("background-image", "url(" + bgData + ")");
    
    // Show the next button if a style is selected
    $('.next-step1').fadeIn(800);
    $('.step1-lumbar').prop("disabled", false);

    var pillowFinal = pillowSize.replace('-desktop', '');

    // Store the pillow style
    sessionStorage.setItem('_product_builder_style', pillowFinal);

    var base = "";

    if (pillowSize === "small-desktop") {
      base = "lumbar_small";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (pillowSize === "medium-desktop") {
      base = "lumbar_medium";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    if (pillowSize === "large-desktop") {
      base = "lumbar_large";
      sessionStorage.setItem('_product_builder_base_image', base);
    }

    // Change only if the final image is not set
    var finalSet = sessionStorage.getItem('_product_builder_final_image');
    var pbProduct = sessionStorage.getItem('_product_builder_product');

    if (finalSet != null && pbProduct == 'lumbar-pillow') {
      // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
      var getSwatch = sessionStorage.getItem('_product_builder_swatch');
      var lowercaseSwatch = getSwatch.toLowerCase();
      var splitSwatch = lowercaseSwatch.split(" ");
      var combineSwatch = splitSwatch.join("_");

      var removeNull = combineSwatch.replace('-desktop', '');
      var base = sessionStorage.getItem('_product_builder_base_image');
      var imageWithoutExtension = `${base}_${removeNull}`;
      var removeNull2 = imageWithoutExtension.replace('_null', '');
      var finalImage = lumbarLiquidVariable[removeNull2];
      var addBase = finalImage + "_" + base;
      sessionStorage.setItem('_product_builder_final_image', finalImage);

      $('.left-pillows').css("background-image", "url(" + finalImage + ")");

      var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');
      if(hasPiping === 'piping') {
        var getSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
        var lowercaseSwatch = getSwatch.toLowerCase();
        var splitSwatch = lowercaseSwatch.split(" ");
        var combineSwatch = splitSwatch.join("_");

        var removeNull = combineSwatch.replace('-desktop', '');
        var imageWithoutExtension = `${base}_piping_${removeNull}`;
        var removeNull2 = imageWithoutExtension.replace('_null', '');
        var finalImage = lumbarPipingLiquidVariable[removeNull2];
        sessionStorage.setItem('_product_builder_swatch_piping_thumb', finalImage);
        $('.pillows-piping-overlay').css("background-image", "url(" + finalImage + ")");
      }
    }
    
    else {
      var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');
      if(hasPiping === 'piping') {
        var getSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
        var lowercaseSwatch = getSwatch.toLowerCase();
        var splitSwatch = lowercaseSwatch.split(" ");
        var combineSwatch = splitSwatch.join("_");
        var removeNull = combineSwatch.replace('-desktop', '');
        var imageWithoutExtension = `${base}_piping_${removeNull}`;
        var removeNull2 = imageWithoutExtension.replace('_null', '');
        var finalImage = lumbarPipingLiquidVariable[removeNull2];
        sessionStorage.setItem('_product_builder_swatch_piping_thumb', finalImage);
        $('.pillows-piping-overlay').css("background-image", "url(" + finalImage + ")");
      }
    }

  });

  // Step Two - Select Piping Option
  $('.step1-lumbar').click(function(){

    $('.desktop-step1-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step2-lumbar-pillows').fadeIn(400);
    });
  });

  $('.piping-lumbar-desktop').change(function(){
    var hadPiping = sessionStorage.getItem('_product_builder_pillow_piping');

    $('.builder-display-two-column').removeClass('selected-img');

    // Highlight the selected box
    var piping = $('input[name=\'piping-lumbar-desktop\']:checked');
    var parent = piping.closest('.builder-display-two-column');
    parent.addClass("selected-img");

    var pipingThumb = piping.attr("data-thumb");

    sessionStorage.setItem('_product_builder_pillow_piping_thumb', pipingThumb);

    var pipingType = piping.val();

    var pipingFinal = pipingType.replace('-desktop', '');

    sessionStorage.setItem('_product_builder_pillow_piping',pipingFinal);

    if(pipingFinal === 'none') {
      $('.pillows-piping-overlay').hide();
        $('.pillow-piping').hide();
    } 
    else {
      var currentPipingSwatch = sessionStorage.getItem('_product_builder_swatch_piping_thumb');
      if (currentPipingSwatch) {
      }
      else {
        var base = sessionStorage.getItem('_product_builder_base_image');
        var imageWithoutExtension = `${base}_piping_deep_sea`;
        var removeNull2 = imageWithoutExtension.replace('_null', '');
        var pipingFinal = lumbarPipingLiquidVariable[removeNull2];
        sessionStorage.setItem('_product_builder_swatch_piping_thumb', pipingFinal);
        // Store the fabric swatch
    	sessionStorage.setItem('_product_builder_piping_swatch', 'Deep Sea');
        $('.pillows-piping-overlay').css("background-image", "url(" + pipingFinal + ")");
      } 
      $('.pillows-piping-overlay').show();
      if (hadPiping === 'none') {
        $('.step2-lumbar').prop("disabled", false);
        $('.summary-hidden-2').hide();
      }
    }
    // Show the next button if a style is selected
    $('.next-step2').fadeIn(800);
    $('.step2-lumbar').prop("disabled", false);
  });

  // Go back from Piping on Lumbar Pillows to Size
  $('.go-back-desktop-lumbar-size').click(function(){
    $('.desktop-step2-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step1-lumbar-pillows').fadeIn(400);
    });

  });

  // Go back from Fabric on Lumbar Pillows to Piping
  $('.go-back-desktop-lumbar-piping').click(function(){
    $('.desktop-step3-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step2-lumbar-pillows').fadeIn(400);
    });

  });

  // Step Three - Select Fabric Options (x2)
  $('.step2-lumbar').click(function(){
    $('.desktop-step2-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step3-lumbar-pillows').fadeIn(400);
      var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');
      // If piping is selected, show the pillow piping option
      if (hasPiping === "piping") {
        $('.pillow-piping').show();
      }
    });

  });

  $('.swatch-lumbar-desktop').change(function(){

    //$('.swatch-slide').css("border-top","");
    $('.swatches-list-pillow .swatch-slide').removeClass("swatch-selected");

    // Highlight the selected box
    var selectedSwatch = $('input[name=\'swatch-lumbar-desktop\']:checked');

    var parent = selectedSwatch.closest('.swatch-slide');
    //parent.css("border-top","10px solid #8b634b");
    parent.addClass("swatch-selected");

    var swatch = selectedSwatch.val();
    var swatchThumb = selectedSwatch.attr('data-thumb');
    sessionStorage.setItem('_product_builder_swatch_thumb', swatchThumb);
    var swatchFinal = swatch.replace('-lumbar-swatch-desktop', '');
    // Store the fabric swatch
    sessionStorage.setItem('_product_builder_swatch', swatchFinal);
    // Show the next button if a fabric is selected
    $('.next-step3').fadeIn(800);
    $('.step3-lumbar').prop("disabled", false);

    // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
    var lowercaseSwatch = swatch.toLowerCase();
    var splitSwatch = lowercaseSwatch.split(" ");
    var combineSwatch = splitSwatch.join("_");
    var removeNull = combineSwatch.replace('-lumbar-swatch-desktop', '');
    var base = sessionStorage.getItem('_product_builder_base_image');
    var imageWithoutExtension = `${base}_${removeNull}`;
    var removeNull2 = imageWithoutExtension.replace('_null', '');
    var finalImage = lumbarLiquidVariable[removeNull2];
    var addBase = finalImage + "_" + base;
    $('.left-pillows').css("background-image", "url(" + finalImage + ")");
    sessionStorage.setItem('_product_builder_final_image', finalImage);
  });

  $('.swatch-lumbar-piping-desktop').change(function(){

    // Highlight the selected box
    $('.swatches-list-piping .swatch-slide').removeClass("swatch-selected");
    // Highlight the selected box
    var selectedPiping = $('input[name=\'swatch-lumbar-piping-desktop\']:checked');
    var parent = selectedPiping.closest('.swatch-slide');
    parent.addClass("swatch-selected");
    var pipingSwatch = selectedPiping.val();
    var pipingFirst = pipingSwatch.replace('-lumbar-piping-swatch-desktop', '');
    // Store the fabric swatch
    sessionStorage.setItem('_product_builder_piping_swatch', pipingFirst);
    var base = sessionStorage.getItem('_product_builder_base_image');
    pipingFirst = pipingFirst.toLowerCase();
    pipingFirst = pipingFirst.replace(' ', '_');
    var imageWithoutExtension = `${base}_piping_${pipingFirst}`;
    var removeNull2 = imageWithoutExtension.replace('_null', '');
    var pipingFinal = lumbarPipingLiquidVariable[removeNull2];
    sessionStorage.setItem('_product_builder_swatch_piping_thumb', pipingFinal);
    $('.pillows-piping-overlay').css("background-image", "url(" + pipingFinal + ")");

  });


  // Summary - View Customized Lumbar Pillow
  $('.step3-lumbar').click(function(){
    $('.desktop-step3-lumbar-pillows').fadeOut(400, function () {
      $('.lumbar-start-over').show();
      $('.desktop-summary-lumbar-pillows').fadeIn(400);
    });
    calcPriceLumbarPillow();
  });

  // Modify Size
  $('.lumbar-size-final-button').click(function(){
    $('.desktop-summary-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step1-lumbar-pillows').fadeIn(400);
      $('.summary-hidden-1').show();
      $('.lumbar-start-over').hide();
      $('.step1-lumbar').hide();
    });
  });

  // Modify Piping
  $('.lumbar-piping-final-button').click(function(){
    $('.desktop-summary-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step2-lumbar-pillows').fadeIn(400);
      $('.summary-hidden-2').show();
      $('.go-back-desktop-lumbar-size').hide();
      $('.lumbar-start-over').hide();
      $('.step2-lumbar').hide();
    });
  });

  // Modify Fabric
  $('.lumbar-fabric-final-button').click(function(){
    $('.desktop-summary-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step1-lumbar-pillows').hide();
      $('.lumbar-start-over').hide();
      $('.desktop-step3-lumbar-pillows').fadeIn(400);
      $('.go-back-desktop-lumbar-piping').hide();
      var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');
      // If piping is selected, show the pillow piping option
      if (hasPiping === "piping") {
        $('.pillow-piping').show();
      }
    });
  });

  $('.lumbar-piping-fabric-final-button').click(function(){
    $('.desktop-summary-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step1-lumbar-pillows').hide();
      $('.lumbar-start-over').hide();
      $('.go-back-desktop-lumbar-size').hide();
      $('.desktop-step3-lumbar-pillows').fadeIn(400);
    });
  });

  // Return to Summary
  $('.summary-hidden-1-button').click(function(){
    $('.desktop-step1-lumbar-pillows').fadeOut(400, function () {
      $('.lumbar-start-over').show();
      $('.desktop-summary-lumbar-pillows').fadeIn(400);
    });
    calcPriceLumbarPillow();
  });

  $('.summary-hidden-2-button').click(function(){
    $('.desktop-step2-lumbar-pillows').fadeOut(400, function () {
      $('.lumbar-start-over').show();
      $('.desktop-summary-lumbar-pillows').fadeIn(400);
    });
    calcPriceLumbarPillow();
  });


  // Add a Lumbar Pillow to the Cart
  $('.add-to-cart-lumbar-desktop').click(function(){
    $('.add-to-cart-lumbar-desktop').css("background-color","#cdb2a2")
    $('.add-to-cart-lumbar-desktop').html("<img src='https://cdn.shopify.com/s/files/1/2435/4739/t/2/assets/ajax-loader.gif?27652' style='width: 16px !important;; height: 16px !important;'>");

    // Set Variables
    var pillowSize = capitalize(sessionStorage.getItem('_product_builder_style'));
    var pillowSwatch = sessionStorage.getItem('_product_builder_swatch');
    var pipingCheck = capitalize(sessionStorage.getItem('_product_builder_pillow_piping'));
    var pipingSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
    var theImage = sessionStorage.getItem('_product_builder_final_image');
    var finalPrice = sessionStorage.getItem('_product_builder_final_cost');
    // Strip the version off the prodcut image
    // Append 'https' to the front of the file name
    var imageSplit = theImage.split("?");
    var imageNoVersion = imageSplit[0];
    var imageLead = "https:";
    var finalImage = imageLead.concat(imageNoVersion);

    if (document.querySelector("meta[name='storeauthtoken']")) {
      token = document.querySelector("meta[name='storeauthtoken']").getAttribute("content");
    }

    // Call the API -- returned variable will be "variantID"
    $.ajax({
      url: 'https://app.wovnhome.com/v1/create-product',
      type: 'post',
      crossDomain: true,
      contentType: "application/json",
      dataType: 'json',
      headers: {
        'storeauthtoken': token,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        "type": "Pillow",
        "style": "Lumbar",
        "fabric": pillowSwatch,
        "piping": pipingCheck,
        "prodImgURL": finalImage,
        "pricePerUnit": finalPrice
      }),
      success: function (variantID) {
        var a = variantID.variantID;
        var storedVariant = parseInt(a);
        // Now add to the cart. Liner and chain placement (for blinds) are line item properties.
        jQuery.post('/cart/add.js', {
          quantity: 1,
          id: storedVariant,
          properties: {
            'Size': pillowSize,
            'Piping Fabric': pipingSwatch
          },

          success: function () {
            // Clear local storage
            sessionStorage.clear();
            // Redirect to the cart
            setTimeout(function() {
              $('.add-to-cart-lumbar-desktop').hide();
              $('.go-to-cart-pillows').fadeIn(400);
              window.location.assign('/cart/');
            }, 1000);
          }
        });
        // Also add a spinner while things are loading, and hide the add to cart button
      },
      error: function () {
        console.log("The request failed");
      }
    });

  });


  // START SQUARE PILLOWS
  $('.custom-square-pillows').click(function(){
    // Store the product type
    sessionStorage.setItem('_product_builder_product', 'square-pillow');
    $('.desktop-select-product').fadeOut(400, function () {
      $('.pillows-square').fadeIn(400);
      $('.desktop-step1-square-pillows').fadeIn(400);
    });
    // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
    sessionStorage.setItem('_product_builder_stage', 'pillows-square');
  });

  // Step One - Select Size
  $('.size-square-desktop').change(function(){
    // Store the product type
    sessionStorage.setItem('_product_builder_product', 'square-pillow');
    $('.builder-display-three-column').removeClass('selected-img');
    // Highlight the selected box
    var size = $('input[name=\'size-square-desktop\']:checked');
    var parent = size.closest('.builder-display-three-column');
    parent.addClass("selected-img");
    var sizeThumb = size.attr("data-thumb");
    sessionStorage.setItem('_product_builder_pillow_size_thumb', sizeThumb);
    // Change the image to reflect the correct style
    var pillowSize = size.val();
    // Get the data-bg value for the set item
    var bgData = size.attr('data-bg');
    // Show the next button if a style is selected
    $('.next-step1').fadeIn(800);
    $('.step1-square').prop("disabled", false);
    var pillowFinal = pillowSize.replace('-desktop', '');
    // Store the drape style
    sessionStorage.setItem('_product_builder_style', pillowFinal);
    $('.left-pillows').removeClass("small-pillow");
    $('.left-pillows').removeClass("medium-pillow");
    $('.left-pillows').removeClass("large-pillow");
    $('.left-pillows').addClass(pillowFinal+'-pillow');
    var base = "";
    if (pillowSize === "small-desktop") {
      base = "square_small";
      sessionStorage.setItem('_product_builder_base_image', base);
    }
    if (pillowSize === "medium-desktop") {
      base = "square_small";
      sessionStorage.setItem('_product_builder_base_image', base);
    }
    if (pillowSize === "large-desktop") {
      base = "square_small";
      sessionStorage.setItem('_product_builder_base_image', base);
    }
    // Change only if the final image is not set
    var finalSet = sessionStorage.getItem('_product_builder_final_image');
    var pbProduct = sessionStorage.getItem('_product_builder_product');

    if (finalSet != null && pbProduct == 'square-pillow') {
      // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
      var getSwatch = sessionStorage.getItem('_product_builder_swatch');
      var lowercaseSwatch = getSwatch.toLowerCase();
      var splitSwatch = lowercaseSwatch.split(" ");
      var combineSwatch = splitSwatch.join("_");
      var removeNull = combineSwatch.replace('-desktop', '');
      var base = 'square';
      var imageWithoutExtension = `${base}_${removeNull}`;
      var removeNull2 = imageWithoutExtension.replace('_null', '');
      var finalImage = squareLiquidVariable[removeNull2];
      var addBase = finalImage + "_" + base;
      sessionStorage.setItem('_product_builder_final_image', finalImage);
      $('.left-pillows').css("background-image", "url(" + finalImage + ")");

      var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');
      if(hasPiping === 'piping') {
        var getSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
        var lowercaseSwatch = getSwatch.toLowerCase();
        var splitSwatch = lowercaseSwatch.split(" ");
        var combineSwatch = splitSwatch.join("_");
        var removeNull = combineSwatch.replace('-desktop', '');
        var imageWithoutExtension = `${base}_piping_${removeNull}`;
        var removeNull2 = imageWithoutExtension.replace('_null', '');
        var finalImage = squarePipingLiquidVariable[removeNull2];
        sessionStorage.setItem('_product_builder_swatch_piping_thumb', finalImage);
        $('.pillows-piping-overlay').css("background-image", "url(" + finalImage + ")");
      }
    }

  });

  // Step Two - Select Piping Option
  $('.step1-square').click(function(){

    $('.desktop-step1-square-pillows').fadeOut(400, function () {
      $('.desktop-step2-square-pillows').fadeIn(400);
    });
  });

  $('.piping-square-desktop').change(function(){
    var hadPiping = sessionStorage.getItem('_product_builder_pillow_piping');

    // Highlight the selected box
    $('.builder-display-two-column').removeClass("selected-img");

    // Highlight the selected box
    var piping = $('input[name=\'piping-square-desktop\']:checked');
    var parent = piping.closest('.builder-display-two-column');
    parent.addClass("selected-img");
    var pipingThumb = piping.attr("data-thumb");
    sessionStorage.setItem('_product_builder_pillow_piping_thumb', pipingThumb);
    var pipingType = piping.val();
    var pipingFinal = pipingType.replace('-desktop', '');
    sessionStorage.setItem('_product_builder_pillow_piping',pipingFinal);
    if(pipingFinal === 'none') {
      $('.pillows-piping-overlay').hide();
        $('.pillow-piping').hide();
    } 
    else {
      var currentPipingSwatch = sessionStorage.getItem('_product_builder_swatch_piping_thumb');
      if (currentPipingSwatch) {
      }
      else {
        var imageWithoutExtension = `square_piping_deep_sea`;
        var removeNull2 = imageWithoutExtension.replace('_null', '');
        var newPipingFinal = squarePipingLiquidVariable[removeNull2];
        sessionStorage.setItem('_product_builder_swatch_piping_thumb', newPipingFinal);
        $('.pillows-piping-overlay').css("background-image", "url(" + newPipingFinal + ")");
      }
      $('.pillows-piping-overlay').show();
      
      if (hadPiping === 'none') {
        $('.step2-square').fadeIn(800);
        $('.summary-hidden-2').hide();
      }
    }
    // Show the next button if a style is selected
    $('.next-step2').fadeIn(800);
    $('.step2-square').prop("disabled", false);
  });

  // Go back from Piping on square Pillows to Size
  $('.go-back-desktop-square-size').click(function(){
    $('.desktop-step2-square-pillows').fadeOut(400, function () {
      $('.desktop-step1-square-pillows').fadeIn(400);
    });
  });

  // Go back from Fabric on square Pillows to Piping
  $('.go-back-desktop-square-piping').click(function(){
    $('.desktop-step3-square-pillows').fadeOut(400, function () {
      $('.desktop-step2-square-pillows').fadeIn(400);
    });
  });

  // Step Three - Select Fabric Options (x2)
  $('.step2-square').click(function(){
    $('.desktop-step2-square-pillows').fadeOut(400, function () {
      $('.desktop-step3-square-pillows').fadeIn(400);
      var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');
      // If piping is selected, show the pillow piping option
      if (hasPiping === "piping") {
        $('.pillow-piping').show();
      }
    });
  });

  $('.swatch-square-desktop').change(function(){
    // Highlight the selected box
    $('.swatches-list-pillow .swatch-slide').removeClass("swatch-selected");

    // Highlight the selected box
    var selectedSwatch = $('input[name=\'swatch-square-desktop\']:checked');
    var parent = selectedSwatch.closest('.swatch-slide');
    //parent.css("border-top","10px solid #8b634b");
    parent.addClass("swatch-selected");
    var swatch = selectedSwatch.val();
    var swatchThumb = selectedSwatch.attr('data-thumb');
    sessionStorage.setItem('_product_builder_swatch_thumb', swatchThumb);
    var swatchFinal = swatch.replace('-square-swatch-desktop', '');
    // Store the fabric swatch
    sessionStorage.setItem('_product_builder_swatch', swatchFinal);
    // Show the next button if a fabric is selected
    $('.next-step3').fadeIn(800);
    $('.step3-square').prop("disabled", false);
    // Switch the image; change the swatch title to all lowercase, change spaces to have hyphens, get the style type
    var lowercaseSwatch = swatch.toLowerCase();
    var splitSwatch = lowercaseSwatch.split(" ");
    var combineSwatch = splitSwatch.join("_");
    var removeNull = combineSwatch.replace('-square-swatch-desktop', '');
    var base = 'square';
    var imageWithoutExtension = `${base}_${removeNull}`;
    var removeNull2 = imageWithoutExtension.replace('_null', '');
    var finalImage = squareLiquidVariable[removeNull2];
    $('.left-pillows').css("background-image", "url(" + finalImage + ")");
    sessionStorage.setItem('_product_builder_final_image', finalImage);
  });

  $('.swatch-square-piping-desktop').change(function(){
    // Highlight the selected box
    $('.swatches-list-piping .swatch-slide').removeClass("swatch-selected");

    // Highlight the selected box
    var selectedPiping = $('input[name=\'swatch-square-piping-desktop\']:checked');

    var parent = selectedPiping.closest('.swatch-slide');
    //parent.css("border-top","10px solid #8b634b");
    parent.addClass("swatch-selected");
    var pipingSwatch = selectedPiping.val();
    var pipingFirst = pipingSwatch.replace('-square-piping-swatch-desktop', '');
    // Store the fabric swatch
    sessionStorage.setItem('_product_builder_piping_swatch', pipingFirst);
    var base = "square";
    pipingFirst = pipingFirst.toLowerCase();
    pipingFirst = pipingFirst.replace(' ', '_');
    var imageWithoutExtension = `${base}_piping_${pipingFirst}`;
    var removeNull2 = imageWithoutExtension.replace('_null', '');
    var pipingFinal = squarePipingLiquidVariable[removeNull2];
    sessionStorage.setItem('_product_builder_swatch_piping_thumb', pipingFinal);
    $('.pillows-piping-overlay').css("background-image", "url(" + pipingFinal + ")");
  });


  // Summary - View Customized square Pillow
  $('.step3-square').click(function(){
    $('.desktop-step3-square-pillows').fadeOut(400, function () {
      $('.square-start-over').show();
      $('.desktop-summary-square-pillows').fadeIn(400);
    });
    calcPriceSquarePillow();
  });

  // Modify Size
  $('.square-size-final-button').click(function(){
    $('.desktop-summary-square-pillows').fadeOut(400, function () {
      $('.desktop-step1-square-pillows').fadeIn(400);
      $('.square-start-over').hide();
      $('.summary-hidden-1').show();
      $('.step1-square').hide();
    });
  });

  // Modify Piping
  $('.square-piping-final-button').click(function(){
    $('.desktop-summary-square-pillows').fadeOut(400, function () {
      $('.desktop-step1-square-pillows').hide();
      $('.go-back-desktop-square-size').hide();
      $('.square-start-over').hide();
      $('.desktop-step2-square-pillows').fadeIn(400);
      $('.summary-hidden-2').show();
      $('.step2-square').hide();

    });
  });

  // Modify Fabric
  $('.square-fabric-final-button').click(function(){
    $('.go-back-desktop-square-piping').hide();
    $('.square-start-over').hide();
    $('.desktop-summary-square-pillows').fadeOut(400, function () {
      $('.desktop-step3-square-pillows').fadeIn(400);
    });
  });

  $('.square-piping-fabric-final-button').click(function(){
    $('.desktop-summary-square-pillows').fadeOut(400, function () {
      $('.desktop-step3-square-pillows').fadeIn(400);
    });
  });

  // Return to Summary
  $('.summary-hidden-1-button').click(function(){
    $('.desktop-step1-square-pillows').fadeOut(400, function () {
      $('.square-start-over').show();
      $('.desktop-summary-square-pillows').fadeIn(400);
    });
    calcPriceSquarePillow();
  });

  $('.summary-hidden-2-button').click(function(){
    $('.desktop-step2-square-pillows').fadeOut(400, function () {
      $('.square-start-over').show();
      $('.desktop-summary-square-pillows').fadeIn(400);
    });
    calcPriceSquarePillow();
  });


  // Add a square Pillow to the Cart
  $('.add-to-cart-square-desktop').click(function(){
    $('.add-to-cart-square-desktop').css("background-color","#cdb2a2")
    $('.add-to-cart-square-desktop').html("<img src='https://cdn.shopify.com/s/files/1/2435/4739/t/2/assets/ajax-loader.gif?27652' style='width: 16px !important;; height: 16px !important;'>");

    // Set Variables
    var pillowSize = capitalize(sessionStorage.getItem('_product_builder_style'));
    var pillowSwatch = sessionStorage.getItem('_product_builder_swatch');
    var pipingCheck = capitalize(sessionStorage.getItem('_product_builder_pillow_piping'));
    var pipingSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
    var theImage = sessionStorage.getItem('_product_builder_final_image');
    var finalPrice = sessionStorage.getItem('_product_builder_final_cost');
    // Strip the version off the prodcut image
    // Append 'https' to the front of the file name
    var imageSplit = theImage.split("?");
    var imageNoVersion = imageSplit[0];
    var imageLead = "https:";
    var finalImage = imageLead.concat(imageNoVersion);
    if (document.querySelector("meta[name='storeauthtoken']")) {
      token = document.querySelector("meta[name='storeauthtoken']").getAttribute("content");
    }

    // Call the API -- returned variable will be "variantID"
    $.ajax({
      url: 'https://app.wovnhome.com/v1/create-product',
      type: 'post',
      crossDomain: true,
      contentType: "application/json",
      dataType: 'json',
      headers: {
        'storeauthtoken': token,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        "type": "Pillow",
        "style": "Square",
        "fabric": pillowSwatch,
        "piping": pipingCheck,
        "prodImgURL": finalImage,
        "pricePerUnit": finalPrice
      }),
      success: function (variantID) {
        var a = variantID.variantID;
        var storedVariant = parseInt(a);

        // Now add to the cart. Liner and chain placement (for blinds) are line item properties.
        jQuery.post('/cart/add.js', {
          quantity: 1,
          id: storedVariant,
          properties: {
            'Size': pillowSize,
            'Piping Fabric': pipingSwatch
          },

          success: function () {
            // Clear local storage
            sessionStorage.clear();
            // Redirect to the cart
            setTimeout(function() {
              $('.add-to-cart-square-desktop').hide();
              $('.go-to-cart-pillows').fadeIn(400);
              window.location.assign('/cart/');
            }, 1000)

          }
        });
        // Also add a spinner while things are loading, and hide the add to cart button
      },
      error: function () {
        console.log("The request failed");
      }
    });
  });

  // END DESKTOP

  $('.manual-measurements-trigger').on("click", function () {
    $('.manual-measurements').fadeIn(400);
  });

});

$('.panel_count_inc').on('click', function() {
  var currentVal = $('.panel_count').html();
  var newVal = parseInt(currentVal) + 1;
  $('.panel_count').html(newVal);
});

$('.panel_count_dec').on('click', function() {
  var currentVal = $('.panel_count').html();
  if (parseInt(currentVal) > 1) {
    var newVal = parseInt(currentVal) - 1;
    $('.panel_count').html(newVal);
  }
});

$('.drapes-start-over').click(function() {
  // Scroll to the top of the window
  $( "body" ).scrollTop( 0 );
  sessionStorage.clear();
  $('.desktop-step-summary-drapes').fadeOut(400, function () {
    $('.desktop-step-2-drapes').fadeOut(400, function () {
      $('.desktop-step-4-drapes').fadeOut(400, function () {
        $('.desktop-step-5-drapes').fadeOut(400, function () {
          $('.desktop-step-1-drapes').fadeIn(400);
          $('.selected-img').removeClass('selected-img');        
          $('.swatch-selected').removeClass('swatch-selected');
          $('input').prop('checked', false);
          $('.next-step1').find('.call-to-action').prop('disabled', true);
          $('.step2-drapes').prop('disabled', true);
          $('.step4-drapes').prop('disabled', true);
        });
      });
    });
  });
});

$('.blinds-start-over').click(function() {
  // Scroll to the top of the window
  $( "body" ).scrollTop( 0 );
  sessionStorage.clear();
  $('.desktop-summary-blinds').fadeOut(400, function () {
    $('.desktop-step2-blinds').fadeOut(400, function () {
      $('.desktop-step3-blinds').fadeOut(400, function () {
        $('.desktop-step4-blinds').fadeOut(400, function () {
          $('.desktop-step5-blinds').fadeOut(400, function () {
            $('.desktop-step1-blinds').fadeIn(400);
            $('.step1-blinds').show();
            $('.selected-img').removeClass('selected-img');        
          	$('.swatch-selected').removeClass('swatch-selected');
            $('input').prop('checked', false);
            $('.next-step1').find('.call-to-action').prop('disabled', true);
            $('.step2-blinds').find('.call-to-action').prop('disabled', true);
            $('.step3-blinds').find('.call-to-action').prop('disabled', true);
            $('.step4-blinds').find('.call-to-action').prop('disabled', true);
          });
        });
      });
    });
  });
});

$('.lumbar-start-over').click(function() {
  // Scroll to the top of the window
  $( "body" ).scrollTop( 0 );
  clearProductBuilder();
  $('.desktop-summary-lumbar-pillows').fadeOut(400, function () {
    $('.desktop-step2-lumbar-pillows').fadeOut(400, function () {
      $('.desktop-step3-lumbar-pillows').fadeOut(400, function () {
        $('.desktop-step1-lumbar-pillows').fadeIn(400);
        $('.selected-img').removeClass('selected-img');
        $('.swatch-selected').removeClass('swatch-selected');
        $('input').prop('checked', false);
        $('.next-step1').find('.call-to-action').prop('disabled', true);
        $('.next-step2').find('.call-to-action').prop('disabled', true);
        $('.next-step3').find('.call-to-action').prop('disabled', true);
        $('.pillow-piping').hide();
        $('.pillows-piping-overlay').css('background-image', 'none');
      });
    });
  });
});

$('.square-start-over').click(function() {
  // Scroll to the top of the window
  $( "body" ).scrollTop( 0 );
  clearProductBuilder();
  $('.desktop-summary-square-pillows').fadeOut(400, function () {
    $('.desktop-step2-square-pillows').fadeOut(400, function () {
      $('.desktop-step3-square-pillows').fadeOut(400, function () {
        $('.desktop-step1-square-pillows').fadeIn(400);
        $('.selected-img').removeClass('selected-img');
        $('.swatch-selected').removeClass('swatch-selected');
        $('input').prop('checked', false);
        $('.next-step1').find('.call-to-action').prop('disabled', true);
        $('.next-step2').find('.call-to-action').prop('disabled', true);
        $('.next-step3').find('.call-to-action').prop('disabled', true);
        $('.pillow-piping').hide();
        $('.pillows-piping-overlay').css('background-image', 'none');
      });
    });
  });
});


// Number functions to handle fraction measurements
function firstNumber(number) {
    var fullNumber = Math.floor(number);
    return fullNumber;
};

function splitDecimal(number) {
    var fullNumber = parseFloat(number);
    var decimal = fullNumber - Math.floor(fullNumber);
    return decimal;
};

function convertDecimal(number) {
    var fullNumber = parseFloat(number);
    var decimal = fullNumber - Math.floor(fullNumber);
    var final = "";
    if (decimal === 0.00) {
        final = "";
    } else if (decimal === 0.125) {
        final = "1/8";
    } else if (decimal === 0.25) {
        final = "1/4";
    } else if (decimal === 0.375) {
        final = "3/8";
    } else if (decimal === 0.5) {
        final = "1/2";
    } else if (decimal === 0.625) {
        final = "5/8";
    } else if (decimal === 0.75) {
        final = "3/4";
    } else if (decimal === 0.875) {
        final = "7/8";
    } else {
        final = "error";
    }
    return final;

};

function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1)
};


function goToSummaryDrapes() {
  // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
  sessionStorage.setItem('_product_builder_stage', 'desktop-step-summary-drapes');

  // If the measurements from the fit finder are set, pre-load the selection fields in the next step with the final width and height values. Make sure its for drapes.
  var fitFinderSet = sessionStorage.getItem('_fit_finder_complete');
  var fitFinderStyle = sessionStorage.getItem('_fit_finder_style');
  var productBuildStyle = sessionStorage.getItem('_product_builder_style');
  var styleNameSplit = productBuildStyle.split("-");
  var styleName1 = styleNameSplit[0].concat(" ");
  var styleName = styleName1.concat(styleNameSplit[1]);
  var styleRemoveNull = styleName.replace(" undefined", "");
  var styleImg = sessionStorage.getItem('_product_builder_style_thumb');
  var swatchImg = sessionStorage.getItem('_product_builder_swatch_thumb');
  var panelsImg = sessionStorage.getItem('_product_builder_panels_thumb');
  var linerImg = sessionStorage.getItem('_product_builder_liner_thumb');
  var swatchName = sessionStorage.getItem('_product_builder_swatch');
  var panelsName = sessionStorage.getItem('_product_builder_drapes_panels');
  var linerName = sessionStorage.getItem('_product_builder_drapes_liner');
  var finalImage = sessionStorage.getItem('_product_builder_final_image');
  var panelWidthStorage = sessionStorage.getItem('')
  var fitFinderDrapeWidth = sessionStorage.getItem('_fit_finder_final_width');
  var fitFinderDrapeHeight = sessionStorage.getItem('_fit_finder_final_height');

  var heightConverted = splitDecimal(fitFinderDrapeHeight);
  var widthConverted = splitDecimal(fitFinderDrapeWidth);

  var heightFirst = firstNumber(fitFinderDrapeHeight);
  var widthFirst = firstNumber(fitFinderDrapeWidth);

  var heightFraction = convertDecimal(fitFinderDrapeHeight);
  var widthFraction = convertDecimal(fitFinderDrapeWidth);

  // Log the value of the width and height
  sessionStorage.setItem('_product_builder_width', fitFinderDrapeWidth);
  sessionStorage.setItem('_product_builder_height', fitFinderDrapeHeight);

  $('.drapes-height').val(heightFirst);
  $('.drapes-width').val(widthFirst);

  $('.drapes-height-eighths').val(heightConverted);
  $('.drapes-width-eighths').val(widthConverted);

  $('.drapes-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " +swatchName);
  $('.drapes-liner-final').html("<span class='summary-titles'>Lining</span><br><br><img src='" + linerImg + "'><br>" + linerName);

  if (widthFraction != "") {
    $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + widthFirst + "″ - " + widthFraction + "</div>");
  }
  else if (!widthFraction) {
    $('.panel-width').html("<span class='summary-titles'>Panel Width:</span><br><div class='display-box'>" + widthFirst + "″</div>");
  }

  if (heightFraction != "") {
    $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + heightFirst + "″ - " + heightFraction + "</div>");
  }
  else {
    $('.panel-height').html("<span class='summary-titles'>Panel Height:</span><br><div class='display-box'>" + heightFirst + "″</div>");
  }
  
  
  // Grab all the variables from local storage
  var width = parseFloat(sessionStorage.getItem('_product_builder_width'));
  var height = parseFloat(sessionStorage.getItem('_product_builder_height'));

  var panelsString = sessionStorage.getItem('_product_builder_drapes_panels');
  let panels = 1;

  if (panelsString === "single") {
    panels = 1;
  } else if (panelsString === "double") {
    panels = 2;
  }

  var fabric = sessionStorage.getItem('_product_builder_swatch');
  var liner = sessionStorage.getItem('_product_builder_drapes_liner');
  var prodImage = sessionStorage.getItem('_product_builder_final_image');

  // Calculate the price.
  calcPriceDrapes();
  
  $('.desktop-step-5-drapes').fadeOut(400, function () {
    $('.drapes-start-over').show();
    $('.desktop-step-summary-drapes').fadeIn(400);
  });
}

function goToSummaryBlinds() {
  // Set the measurements
  var blindsWidth = parseFloat($('.blinds-width ').val()) || 0;
  var blindsWidthEighths = parseFloat($('.blinds-width-eighths').val()) || 0;

  var blindsHeight = parseFloat($('.blinds-height').val()) || 0;
  var blindsHeightEighths = parseFloat($('.blinds-height-eighths').val()) || 0;

  var blindsW = blindsWidth + blindsWidthEighths;
  var blindsH = blindsHeight + blindsHeightEighths;

  var heightFraction = convertDecimal(blindsHeightEighths);
  var widthFraction = convertDecimal(blindsWidthEighths);

  // Log the value of the width and height
  sessionStorage.setItem('_product_builder_width', blindsW);
  sessionStorage.setItem('_product_builder_height', blindsH);

  // Set the mount location if it does not exist already
  var ffMountLocation = sessionStorage.getItem('_fit_finder_mountType');
  if (!ffMountLocation) {
    var mountLocation = $('#mount-location-desktop').val();
    sessionStorage.setItem('_fit_finder_mountType', mountLocation);
  }
  // Set the stage as the appropriate div class, to show if someone comes back to the page -- we want them to end up at the correct step!
  sessionStorage.setItem('_product_builder_stage', 'desktop-blinds-select-summary');
  var prodBuild = sessionStorage.getItem('_product_builder_style');
  var styleNameSplit = prodBuild.split("-");
  var styleName1 = styleNameSplit[0].concat(" ");
  var styleName = styleName1.concat(styleNameSplit[1]);
  var styleRemoveNull = styleName.replace(" undefined", "");
  var styleImg = sessionStorage.getItem('_product_builder_style_thumb');
  var swatchImg = sessionStorage.getItem('_product_builder_swatch_thumb');
  var cordImg = sessionStorage.getItem('_product_builder_cord_thumb');
  var cordColourImg = sessionStorage.getItem('_')
  var linerImg = sessionStorage.getItem('_product_builder_liner_thumb');
  var swatchName = sessionStorage.getItem('_product_builder_swatch');
  var linerName = sessionStorage.getItem('_product_builder_blinds_liner');
  var prodStyle = sessionStorage.getItem('_product_builder_style');
  var cordName = sessionStorage.getItem('_product_builder_cord_placement');
  var blindW = parseFloat(sessionStorage.getItem('_product_builder_width'));
  var blindH = parseFloat(sessionStorage.getItem('_product_builder_height'));
  var heightFirst = firstNumber(blindH);
  var widthFirst = firstNumber(blindW);
  var heightFraction = convertDecimal(blindH);
  var widthFraction = convertDecimal(blindW);
  var finalImage = sessionStorage.getItem('_product_builder_final_image');
  $('.blinds-style-final').html("<span class='summary-titles'>Style - Fabric</span><br><br><img src='" + finalImage + "' height='125px'><br>" + styleRemoveNull + " - " + swatchName);
  $('.blinds-cord-final').html("<span class='summary-titles'>Cord Position</span><br><br><img src='" + cordImg + "'><br>" + cordName);
  $('.blinds-liner-final').html("<span class='summary-titles'>Lining</span><br><br><img src='" + linerImg + "'><br>" + linerName);
  if (widthFraction != "") {
    $('.panel-width').html("<span class='summary-titles'>Shade Width:</span><br><div class='display-box'>" + widthFirst + "″ - " + widthFraction + "</div>");
  }
  else if (!widthFraction) {
    $('.panel-width').html("<span class='summary-titles'>Shade Width:</span><br><div class='display-box'>" + widthFirst + "″</div>");
  }

  if (heightFraction != "") {
    $('.panel-height').html("<span class='summary-titles'>Shade Height:</span><br><div class='display-box'>" + heightFirst + "″ - " + heightFraction + "</div>");
  }
  else {
    $('.panel-height').html("<span class='summary-titles'>Shade Height:</span><br><div class='display-box'>" + heightFirst + "″</div>");
  }

  // Calculate the price.
  calcPriceBlinds();

  $('.desktop-step5-blinds').fadeOut(400, function () {
    $('.blinds-start-over').show();
    $('.desktop-summary-blinds').fadeIn(400);
  });
}

function calcPriceDrapes() {
  // Grab all the variables from local storage
  var width = parseFloat(sessionStorage.getItem('_product_builder_width'));
  var height = parseFloat(sessionStorage.getItem('_product_builder_height'));
  var panelsString = sessionStorage.getItem('_product_builder_drapes_panels');
  let panels = 1;

  if (panelsString === "single") {
    panels = 1;
  } else if (panelsString === "double") {
    panels = 2;
  }
  var fabric = sessionStorage.getItem('_product_builder_swatch');
  var liner = sessionStorage.getItem('_product_builder_drapes_liner');
  var productBuildStyle = sessionStorage.getItem('_product_builder_style');

  // Calculate the price.

  // Labor Cost = (rate/width) x (# of panels) x ((roundup(widthx2)/54))
  // Euro Pleat = No lining: $50 | Privacy: $55 | Blackout: $60
  // Triple Pinch = No lining: $50 | Privacy: $55 | Blackout: $60
  // Flat Top = No lining: $45 | Privacy: $50 | Blackout: $55

  let laborRate = 0;

  let pricePercentageIncrease = 1;

  if (productBuildStyle === "euro") {
    switch (liner) {
      case "none":
        laborRate = 38;
        break;
      case "privacy":
        laborRate = 41;
        break;
      case "blackout":
        laborRate = 48;
        break;
      default:
        laborRate = 38;
    }

    pricePercentageIncrease = 1.5; // 50% increase
  }
  if (productBuildStyle === "triple-pinch") {
    switch (liner) {
      case "none":
        laborRate = 38;
        break;
      case "privacy":
        laborRate = 41;
        break;
      case "blackout":
        laborRate = 48;
        break;
      default:
        laborRate = 38;
    }

    pricePercentageIncrease = 1.75;  // 75% increase
  }
  if (productBuildStyle === "flat-top") {
    switch (liner) {
      case "none":
        laborRate = 38;
        break;
      case "privacy":
        laborRate = 41;
        break;
      case "blackout":
        laborRate = 48;
        break;
      default:
        laborRate = 38;
    }

    pricePercentageIncrease = 1.5; // 50% increase
  }

  let roundUp1 = Math.ceil((width * 2) / 54);
  let laborCost = laborRate * panels * roundUp1;

  // Create an object containing the fabric names and fabric$ / yard values, then another for their repeat value
  let fabricsCost = {
    "Bright White": 18,
    "Ivory": 18,
    "Coral": 18,
    "Celadon": 18,
    "Fog": 18,
    "Deep Sea": 18,
    "Flax": 18,
    "Oatmeal": 18,
    "Striped Oyster": 18,
    "Jungle Garden": 22.09,
    "Jungle Dusk": 22.09,
    "Jungle Midnight": 22.09,
    "Jungle Sage": 22.09,
    "Jaipur Sky": 28,
    "Jaipur Mint": 18,
    "Jaipur Gold": 18,
    "Chagall Andaman": 18,
    "Chagall Rose": 18,
    "Chagall Sahara": 18,
    "Textured Blue": 22,
    "Textured Navy": 22,
    "Textured Peony": 22,
    "Textured Marigold": 22, 
    "Textured Lavendar": 22, 
    "Dune": 27.5,
    "Umber": 27.5,
    "Acorn": 27.5,
    "Porcelain Sheer": 27.5,
    "Mushroom Sheer": 27.5,
    "Porcelain Mini Stripe Sheer": 27.5,
    "Moss": 27.5,
    "Textured Grey": 22,
    "Soft Snow": 18,
    "Watercolor Stripe Parsley": 28,
    "Watercolor Stripe Clay": 28,
    "Watercolor Stripe Sand": 28,
    "Watercolor Stripe Chambray": 28,
    "Jacobean": 28,
    "Textured Mint": 22,
    "Textured Sand": 22,
    "Light Stone": 22,
    "Courtyard Rust": 61,
    "Courtyard Lake": 61,
    "Trail Celadon": 61,
    "Trail Terra": 61,
    "Fern Linen": 61,
    "Hollyhock Chalk": 61,
    "Hollyhock Oxford": 61,
    "Hollyhock Rose": 61,
    "Petunia Vivid": 61,
    "Petunia Wave": 61,
    "Textured Sand": 22,
    "Light Stone": 22,
  };

  let fabricsRepeat = {
    "Bright White": 1,
    "Ivory": 1,
    "Coral": 1,
    "Celadon": 1,
    "Fog": 1,
    "Deep Sea": 1,
    "Flax": 1,
    "Oatmeal": 1,
    "Striped Oyster": 1,
    "Jungle Garden": 18,
    "Jungle Dusk": 18,
    "Jungle Midnight": 18,
    "Jungle Sage": 18,
    "Jaipur Sky": 1,
    "Jaipur Mint": 1,
    "Jaipur Gold": 1,
    "Chagall Andaman": 1,
    "Chagall Rose": 1,
    "Chagall Sahara": 1,
    "Textured Blue": 1,
    "Textured Navy": 1,
    "Textured Peony": 1,
    "Textured Marigold": 1,
    "Textured Lavendar": 1,
    "Dune": 1,
    "Umber": 1,
    "Acorn": 1,
    "Porcelain Sheer": 1,
    "Mushroom Sheer": 1,
    "Porcelain Mini Stripe Sheer": 1,
    "Moss": 1,
    "Textured Grey": 1,
    "Soft Snow": 1,
    "Watercolor Stripe Parsley": 1,
    "Watercolor Stripe Clay": 1,
    "Watercolor Stripe Sand": 1,
    "Watercolor Stripe Chambray": 1,
    "Jacobean": 1,
    "Textured Mint": 1,
    "Textured Sand": 1,
    "Light Stone": 1,
    "Courtyard Rust": 1,
    "Courtyard Lake": 1,
    "Trail Celadon": 1,
    "Trail Terra": 1,
    "Fern Linen": 1,
    "Hollyhock Chalk": 1,
    "Hollyhock Oxford": 1,
    "Hollyhock Rose": 1,
    "Petunia Vivid": 1,
    "Petunia Wave": 1,
    "Textured Sand": 1,
    "Light Stone": 1,
  }

  let linerCostPerYard = 0;

  switch (liner) {
    case "none":
      linerCostPerYard = 0;
      break;
    case "privacy":
      linerCostPerYard = 4;
      break;
    case "blackout":
      linerCostPerYard = 4;
      break;
    default:
      linerCostPerYard = 0;
  }

  // Fabric and Lining Cost = (Round up(width x 2)/54) x (# of panels) x ((roundup(length+10/fabric repeat)) x fabric repeat) x (fabric $/yard + lining $/yard)
  // Lining Cost per Yard = None: $0 | Privacy: $2.61 | Blackout: $3.64

  let fabricPlusLiner = linerCostPerYard + fabricsCost[fabric];
  let fabricRepeat = fabricsRepeat[fabric];
  let finalFabric = (Math.ceil((width * 2) / 54)) * ((Math.ceil((height + 10) / fabricRepeat) * fabricRepeat ) / 36);
  let fabricLinerFinal = finalFabric * fabricPlusLiner;

  // DO THE FINAL PRICING CALCULATION |||| Base Formula: LABOR COST + FABRIC AND LINING COST / 1 - MARGIN(45%)
  let drapesPrice = (laborCost + fabricLinerFinal) / (1 - 0.70) //CALVIN
  drapesPrice = drapesPrice * pricePercentageIncrease;
  let price = drapesPrice.toFixed(0);
  let stringPrice = price.toString();
  sessionStorage.setItem('_product_builder_price', stringPrice);
  var finalPrice = sessionStorage.getItem('_product_builder_price');
  $('.add-to-cart-drapes-desktop').html("Add to Cart - $" + finalPrice);
}

function calcPriceBlinds() {
    var prodBuild = sessionStorage.getItem('_product_builder_style');
    var styleNameSplit = prodBuild.split("-");
    var styleName1 = styleNameSplit[0].concat(" ");
    var styleName = styleName1.concat(styleNameSplit[1]);
    var swatchName = sessionStorage.getItem('_product_builder_swatch');
    var linerName = sessionStorage.getItem('_product_builder_blinds_liner');
    var prodStyle = sessionStorage.getItem('_product_builder_style');
    var blindW = parseFloat(sessionStorage.getItem('_product_builder_width'));
    var blindH = parseFloat(sessionStorage.getItem('_product_builder_height'));

    // Create an object containing the fabric names and fabric$ / yard values, then another for their repeat value
    let fabricsCost = {
        "Bright White": 18,
        "Ivory": 18,
        "Coral": 18,
        "Celadon": 18,
        "Fog": 18,
        "Deep Sea": 18,
        "Flax": 18,
        "Oatmeal": 18,
        "Striped Oyster": 18,
        "Jungle Garden": 22.09,
        "Jungle Dusk": 22.09,
        "Jungle Midnight": 22.09,
        "Jungle Sage": 22.09,
        "Jaipur Sky": 28,
        "Jaipur Mint": 18,
        "Jaipur Gold": 18,
        "Chagall Andaman": 18,
        "Chagall Rose": 18,
        "Chagall Sahara": 18,
        "Textured Blue": 22,
        "Textured Navy": 22,
        "Textured Peony": 22,
        "Textured Marigold": 22,
        "Textured Lavendar": 22,
        "Dune": 27.5,
        "Umber": 27.5,
        "Acorn": 27.5,
        "Porcelain Sheer": 27.5,
        "Mushroom Sheer": 27.5,
        "Porcelain Mini Stripe Sheer": 27.5,
        "Moss": 27.5,
        "Textured Grey": 22,
        "Soft Snow": 18,
        "Watercolor Stripe Parsley": 28,
        "Watercolor Stripe Clay": 28,
        "Watercolor Stripe Sand": 28,
        "Watercolor Stripe Chambray": 28,
        "Jacobean": 28,
        "Textured Mint": 22,
        "Textured Sand": 22,
        "Light Stone": 22,
        "Courtyard Rust": 61,
        "Courtyard Lake": 61,
        "Trail Celadon": 61,
        "Trail Terra": 61,
        "Fern Linen": 61,
        "Hollyhock Chalk": 61,
        "Hollyhock Oxford": 61,
        "Hollyhock Rose": 61,
        "Petunia Vivid": 61,
        "Petunia Wave": 61,
        "Textured Sand": 22,
        "Light Stone": 22,
      };

    let fabricsRepeat = {
        "Bright White": 1,
        "Ivory": 1,
        "Coral": 1,
        "Celadon": 1,
        "Fog": 1,
        "Deep Sea": 1,
        "Flax": 1,
        "Oatmeal": 1,
        "Striped Oyster": 1,
        "Jungle Garden": 18,
        "Jungle Dusk": 18,
        "Jungle Midnight": 18,
        "Jungle Sage": 18,
        "Jaipur Sky": 1,
        "Jaipur Mint": 1,
        "Jaipur Gold": 1,
        "Chagall Andaman": 1,
        "Chagall Rose": 1,
        "Chagall Sahara": 1,
        "Textured Blue": 1,
        "Textured Navy": 1,
        "Textured Peony": 1,
        "Textured Marigold": 1,
        "Textured Lavendar": 1,
        "Dune": 1,
        "Umber": 1,
        "Acorn": 1,
        "Porcelain Sheer": 1,
        "Mushroom Sheer": 1,
        "Porcelain Mini Stripe Sheer": 1,
        "Moss": 1,
        "Textured Grey": 1,
        "Soft Snow": 1,
        "Watercolor Stripe Parsley": 1,
        "Watercolor Stripe Clay": 1,
        "Watercolor Stripe Sand": 1,
        "Watercolor Stripe Chambray": 1,
        "Jacobean": 1,
        "Textured Mint": 1,
        "Textured Sand": 1,
        "Light Stone": 1,
        "Courtyard Rust": 1,
        "Courtyard Lake": 1,
        "Trail Celadon": 1,
        "Trail Terra": 1,
        "Fern Linen": 1,
        "Hollyhock Chalk": 1,
        "Hollyhock Oxford": 1,
        "Hollyhock Rose": 1,
        "Petunia Vivid": 1,
        "Petunia Wave": 1,
        "Textured Sand": 1,
        "Light Stone": 1,
    };

    // Liner cost per yard
    let linerCostPerYard = 0;

    let pricePercentageIncrease = 1;

    switch (linerName) {
        case "none":
            linerCostPerYard = 0;
            pricePercentageIncrease = 1.2; // 20% increase
            break;
        case "privacy":
            linerCostPerYard = 4;
            pricePercentageIncrease = 1.2; // 20% increase
            break;
        case "blackout":
            linerCostPerYard = 9;
            pricePercentageIncrease = 1.35; // 35% increase
            break;
        default:
            linerCostPerYard = 0;
            pricePercentageIncrease = 1.2; // 20% increase
    }
    let laborRate = 0;
    if (prodBuild === "flat") {
        switch (linerName) {
            case "none":
                laborRate = 15;
                break;
            case "privacy":
                laborRate = 15;
                break;
            case "blackout":
                laborRate = 21;
                break;
            default:
                laborRate = 15;
        }
    }
    if (prodBuild === "soft") {
        switch (linerName) {
            case "none":
                laborRate = 15;
                break;
            case "privacy":
                laborRate = 15;
                break;
            case "blackout":
                laborRate = 21;
                break;
            default:
                laborRate = 15;
        }
    }
    if (prodBuild === "ribbed") {
        switch (linerName) {
            case "none":
                laborRate = 19;
                break;
            case "privacy":
                laborRate = 19;
                break;
            case "blackout":
                laborRate = 19;
                break;
            default:
                laborRate = 19;
        }
    }
    // Labor cost -- ((Width X Length) / 144) X Rate/SQ FT
    let laborCost = Math.round((blindW * blindH) / 144) * laborRate;

    // Fabric cost -- ((ROUND(height+10)/repeat)) * repeat (ROUND(width+6)/54)) / 36)* (fabric per yard + lining per yard)
    //Math.ceil((width*2)/54);

    let fabricCost = 0;
    let fabricRepeat = fabricsRepeat[swatchName];
    let fabricPrice = fabricsCost[swatchName];
    let round1 = Math.ceil((blindH + 10) / fabricRepeat);
    let round2 = Math.ceil((blindW + 6) / 54);
    let fabricLining = fabricPrice + linerCostPerYard;
    console.log({fabricCost, fabricRepeat, fabricPrice, round1, round2, fabricLining, swatchName, fabricsRepeat, fabricsCost})
    fabricCost = ((round1 * fabricRepeat * round2) / 36) * (fabricLining);
    // Headrail cost
    let headrail = 0;
    if (blindW > 36) {
        headrail = 68 + (.5 * (blindW - 36));
    } else {
        headrail = 68; //CALVIN
    }

    // DO THE FINAL PRICING CALCULATION |||| Base Formula: LABOR COST + FABRIC AND LINING COST / 1 - MARGIN(60%)
    console.log({laborCost, fabricCost, headrail})
    let blindsPrice = (laborCost + fabricCost + headrail) / (1 - .60); //CALVIN
    blindsPrice = blindsPrice * pricePercentageIncrease; // Added by BentoSMB Dec 3 24
    let price = blindsPrice.toFixed(0);
    let stringPrice = price.toString();
    sessionStorage.setItem('_product_builder_price', stringPrice);
    var finalPrice = sessionStorage.getItem('_product_builder_price');
    $('.add-to-cart-blinds-desktop').html("Add to Cart - $" + finalPrice);
}

function calcPriceLumbarPillow() {
  // Get Variables
  var pillowSizeThumb = sessionStorage.getItem('_product_builder_pillow_size_thumb');
  var pillowSize = sessionStorage.getItem('_product_builder_style');
  var pillowSwatch = sessionStorage.getItem('_product_builder_swatch');
  var pillowSwatchThumb = sessionStorage.getItem('_product_builder_swatch_thumb');
  var pipingCheckThumb = sessionStorage.getItem('_product_builder_pillow_piping_thumb');
  var pipingCheck = sessionStorage.getItem('_product_builder_pillow_piping');
  var pipingSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
  var pipingSwatchThumb = sessionStorage.getItem('_product_builder_swatch_piping_thumb');
  var finalImage = sessionStorage.getItem('_product_builder_final_image');

  // Calculate the price
  let labor = 0;
  let insert = 0;
  let fabYards = 0;
  let fabCostPerYard = 0;
  let pipingYards = 0;
  let pipingCostPerYard = 0;

  let fabricsCost = {
    "Ivory": 18,
    "Coral": 18,
    "Celadon": 18,
    "Fog": 18,
    "Deep Sea": 18,
    "Flax": 18,
    "Oatmeal": 18,
    "Oyster": 18,
    "Jungle Garden": 22.09,
    "Jungle Dusk": 22.09,
    "Jungle Midnight": 22.09,
    "Jungle Sage": 22.09,
    "Jaipur Sky": 28,
    "Jaipur Mint": 18,
    "Jaipur Gold": 18,
    "Chagall Andaman": 18,
    "Chagall Rose": 18,
    "Chagall Sahara": 18,
    "Textured Navy": 22,
    "Textured Peony": 22,
    "Textured Marigold": 22,
    "Textured Lavendar": 22,
    "Dune": 27.5,
    "Umber": 27.5,
    "Acorn": 27.5,
    "Porcelain Sheer": 27.5,
    "Mushroom Sheer": 27.5,
    "Porcelain Mini Stripe Sheer": 27.5,
    "Moss": 27.5,
    "Textured Grey": 22
  };

  fabCostPerYard = fabricsCost[pillowSwatch];
  pipingCostPerYard = fabricsCost[pipingSwatch];

  // No Piping
  if (pipingCheck === "none") {
    switch(pillowSize) {
      case "none":
        insert = 5.50;
        labor = 22.50;
        fabYards = 0.5;
        pipingCostPerYard = 0;
        break;
      case "small":
        insert = 5.50;
        labor = 22.50;
        fabYards = 0.5;
        pipingCostPerYard = 0;
        break;
      case "medium":
        insert = 20;
        labor = 32.50;
        fabYards = 0.75;
        pipingCostPerYard = 0;
        break;
      case "large":
        insert = 25;
        labor = 45;
        fabYards = 1;
        pipingCostPerYard = 0;
        break;
    }
  }
  // Piping
  else if (pipingCheck === "piping") {
    switch(pillowSize) {
      case "none":
        insert = 5.50;
        labor = 36;
        fabYards = 0.5;
        pipingYards = 1;
        break;
      case "small":
        insert = 5.50;
        labor = 36;
        fabYards = 0.5;
        pipingYards = 1;
        break;
      case "medium":
        insert = 20;
        labor = 52;
        fabYards = 0.75;
        pipingYards = 1;
        break;
      case "large":
        insert = 25;
        labor = 72;
        fabYards = 1;
        pipingYards = 1;
        break;
    }
  }
  let finalCost = (((labor + insert) + (fabYards*fabCostPerYard) + (pipingYards*pipingCostPerYard))/(.65)); //CALVIN
  finalCost = finalCost * 4; // Added by BentoSMB Dec 3 24 - was x2 now x4 (additional x2)
  let finalPrice = finalCost.toFixed(0);
  sessionStorage.setItem('_product_builder_final_cost',finalPrice);
  var pipingTitle = "";
  var pipingFabric = "";
  var image = "<img src='" + finalImage + "' height='150px'>";
  if (pipingCheck === 'piping') {
    pipingTitle = "- Piping";
    pipingFabric = " - " + pipingSwatch;
    image = "<div class='piping-summary-wrapper'><img src='" + finalImage + "' height='150px'><img class='piping-summary-overlay' src='" + pipingSwatchThumb +"'></div>";
  }

  // Set the details
  $('.lumbar-size-final').html("<span class='summary-titles'>Pillow Size - Fabric" + pipingTitle + "</span><br><br>" + image + "<br>" + pillowSize + " - " + pillowSwatch + pipingFabric);
  var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');

  if (hasPiping === "piping") {
    $('.lumbar-piping-final').html("Piping Type<br><br><img src='" + pipingCheckThumb + "'><br>" + pipingCheck);
    $('.lumbar-piping-fabric-final').html("Piping Fabric<br><br><img src='" + pipingSwatchThumb + "'><br>" + pipingSwatch);
  }

  if (hasPiping !== "piping") {
    $('.lumbar-piping-fabric-final-button').hide();
    $('.lumbar-piping-final').hide();
    $('.lumbar-piping-fabric-final').hide();
    $('.lumbar-size-final').css("width","100%");
    $('.small-button-summary').css("width","100%");
  }

  $('.add-to-cart-lumbar-desktop').html("Add to Cart - $"+finalPrice); 
}

function calcPriceSquarePillow() {
  // Set Variables
  var pillowSizeThumb = sessionStorage.getItem('_product_builder_pillow_size_thumb');
  var pillowSize = sessionStorage.getItem('_product_builder_style');
  var pillowSwatch = sessionStorage.getItem('_product_builder_swatch');
  var pillowSwatchThumb = sessionStorage.getItem('_product_builder_swatch_thumb');
  var pipingCheckThumb = sessionStorage.getItem('_product_builder_pillow_piping_thumb');
  var pipingCheck = sessionStorage.getItem('_product_builder_pillow_piping');
  var pipingSwatch = sessionStorage.getItem('_product_builder_piping_swatch');
  var pipingSwatchThumb = sessionStorage.getItem('_product_builder_swatch_piping_thumb');
  var finalImage = sessionStorage.getItem('_product_builder_final_image');

  // Calculate the price
  let labor = 0;
  let insert = 0;
  let fabYards = 0;
  let fabCostPerYard = 0;
  let pipingYards = 0;
  let pipingCostPerYard = 0;

  let fabricsCost = {
    "Ivory": 18,
    "Coral": 18,
    "Celadon": 18,
    "Fog": 18,
    "Deep Sea": 18,
    "Flax": 18,
    "Oatmeal": 18,
    "Oyster": 18,
    "Jungle Garden": 22.09,
    "Jungle Dusk": 22.09,
    "Jungle Midnight": 22.09,
    "Jungle Sage": 22.09,
    "Jaipur Sky": 28,
    "Jaipur Mint": 18,
    "Jaipur Gold": 18,
    "Chagall Andaman": 18,
    "Chagall Rose": 18,
    "Chagall Sahara": 18,
    "Textured Navy": 22,
    "Textured Peony": 22,
    "Textured Marigold": 22,
    "Textured Lavendar": 22, 
    "Dune": 27.5,
    "Umber": 27.5,
    "Acorn": 27.5,
    "Porcelain Sheer": 27.5,
    "Mushroom Sheer": 27.5,
    "Porcelain Mini Stripe Sheer": 27.5,
    "Moss": 27.5,
    "Textured Grey": 22
  };

  fabCostPerYard = fabricsCost[pillowSwatch];
  pipingCostPerYard = fabricsCost[pipingSwatch];

  // No Piping
  if (pipingCheck === "none") {
    switch(pillowSize) {
      case "none":
        insert = 8;
        labor = 22.50;
        fabYards = 0.75;
        pipingCostPerYard = 0;
        break;
      case "small":
        insert = 8;
        labor = 22.50;
        fabYards = 0.75;
        pipingCostPerYard = 0;
        break;
      case "medium":
        insert = 9.75;
        labor = 25;
        fabYards = 0.75;
        pipingCostPerYard = 0;
        break;
      case "large":
        insert = 12;
        labor = 30;
        fabYards = 1;
        pipingCostPerYard = 0;
        break;
    }
  }
  // Piping
  else if (pipingCheck === "piping") {
    switch(pillowSize) {
      case "none":
        insert = 8;
        labor = 36;
        fabYards = 0.75;
        pipingYards = 1;
        break;
      case "small":
        insert = 8;
        labor = 36;
        fabYards = 0.75;
        pipingYards = 1;
        break;
      case "medium":
        insert = 9.75;
        labor = 40;
        fabYards = 0.75;
        pipingYards = 1;
        break;
      case "large":
        insert = 12;
        labor = 48;
        fabYards = 1;
        pipingYards = 1;
        break;
    }
  }
  let finalCost = (((labor + insert) + (fabYards*fabCostPerYard) + (pipingYards*pipingCostPerYard))/(.65));
  finalCost = finalCost * 4; // Added by BentoSMB Dec 3 24 - was x2 now x4 (additional x2)
  let finalPrice = finalCost.toFixed(0);
  sessionStorage.setItem('_product_builder_final_cost',finalPrice);
  var pipingTitle = "";
  var pipingFabric = "";
  var image = "<img src='" + finalImage + "' height='150px' style='height: 150px !important;'>";
  if (pipingCheck === 'piping') {
    pipingTitle = "- Piping";
    pipingFabric = " - " + pipingSwatch;
    image = "<div class='piping-summary-wrapper'><img src='" + finalImage + "' height='150px' style='height: 150px !important;'><img class='piping-summary-overlay' src='" + pipingSwatchThumb +"'></div>";
  }

  // Set the details
  $('.square-size-final').html("<span class='summary-titles'>Pillow Size - Fabric" + pipingTitle + "</span><br><br>" + image + "<br>" + pillowSize + " - " + pillowSwatch + pipingFabric);
  var hasPiping = sessionStorage.getItem('_product_builder_pillow_piping');

  if (hasPiping === "piping") {
    $('.square-piping-final').html("Piping Type<br><br><img src='" + pipingCheckThumb + "'><br>" + pipingCheck);
    $('.square-piping-fabric-final').html("Piping Fabric<br><br><img src='" + pipingSwatchThumb + "'><br>" + pipingSwatch);
  }
  if (hasPiping !== "piping") {
    $('.square-piping-final').hide();
    $('.square-piping-fabric-final').hide();
    $('.square-piping-fabric-final-button').hide();
  }

  $('.add-to-cart-square-desktop').html("Add to Cart - $"+finalPrice);
} 


function clearProductBuilder() {
  sessionStorage.removeItem('_product_builder_product');
  sessionStorage.removeItem('_pb_product');
  sessionStorage.removeItem('_pb_prevProduct');
  sessionStorage.removeItem('_product_builder_base_image');
  sessionStorage.removeItem('_product_builder_style');
  sessionStorage.removeItem('_product_builder_style_thumb');
  sessionStorage.removeItem('_product_builder_swatch');
  sessionStorage.removeItem('_product_builder_swatch_thumb');
  sessionStorage.removeItem('_product_builder_panels_thumb');
  sessionStorage.removeItem('_product_builder_drapes_panels');
  sessionStorage.removeItem('_product_builder_stage');
  sessionStorage.removeItem('_product_builder_final_image');
  sessionStorage.removeItem('_product_builder_final_image_type');
  sessionStorage.removeItem('_product_builder_drapes_liner');
  sessionStorage.removeItem('_product_builder_liner_thumb');
  sessionStorage.removeItem('_product_builder_width');
  sessionStorage.removeItem('_product_builder_height');
  sessionStorage.removeItem('_product_builder_price');
  sessionStorage.removeItem('_pb_basepage');
  sessionStorage.removeItem('_pb_goback');
  sessionStorage.removeItem('_pb_camefrom');
  sessionStorage.removeItem('_product_builder_cord_thumb');
  sessionStorage.removeItem('_product_builder_cord_placement');
  sessionStorage.removeItem('_product_builder_blinds_liner');
  sessionStorage.removeItem('_product_builder_pillow_piping');
  sessionStorage.removeItem('_product_builder_pillow_piping_thumb');
  sessionStorage.removeItem('_product_builder_piping_swatch');
  sessionStorage.removeItem('_product_builder_swatch_piping_thumb');
  sessionStorage.removeItem('_product_builder_final_cost');
  sessionStorage.removeItem('_product_builder_pillow_size_thumb');
  sessionStorage.removeItem('_product_builder_length');
  sessionStorage.removeItem('_product_builder_rings');
  
  sessionStorage.removeItem('_fit_finder_complete');
  sessionStorage.removeItem('_fit_finder_style');
  sessionStorage.removeItem('_fit_finder_rod_status');
  sessionStorage.removeItem('_fit_finder_panel_go_back');
  sessionStorage.removeItem('_fit_finder_rod_width');
  sessionStorage.removeItem('_fit_finder_rod_height');
  sessionStorage.removeItem('_fit_finder_panel_type');
  sessionStorage.removeItem('_fit_finder_fall_style');
  sessionStorage.removeItem('_fit_finder_fall_measurement');
  sessionStorage.removeItem('_fit_finder_final_width');
  sessionStorage.removeItem('_fit_finder_final_height');
  sessionStorage.removeItem('_fit_finder_summary_goback');
  sessionStorage.removeItem('_fit_finder_drape_window_width');
  sessionStorage.removeItem('_fit_finder_drape_window_extension');
  sessionStorage.removeItem('_fit_finder_drape_window_top');
  sessionStorage.removeItem('_fit_finder_rod_mount_height');
  sessionStorage.removeItem('_fit_finder_mountType');
  sessionStorage.removeItem('_fit_finder_height');
  sessionStorage.removeItem('_fit_finder_width');
  sessionStorage.removeItem('_fit_finder_extension');
  sessionStorage.removeItem('_fit_finder_mountTotal');
}

